function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4409",
    viewBox: "0 0 79.374996 79.375002",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-217.62499)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 c 0,0 2.220738,-41.99749 17.446625,-30.8236 l -17.446625,30.8236",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 c 0,0 -19.741373,-38.63516 -0.791633,-36.26344 l 0.791633,36.26344",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 c 0,0 -33.2209052,-21.74487 -16.473628,-29.65662 l 16.473628,29.65662",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 c 0,0 -43.3292452,-2.22144 -31.8008692,-17.44627 l 31.8008692,17.44627",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 c 0,0 -38.63480916,19.74039 -36.2633672,0.79163 l 36.2633672,-0.79163",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 c 0,0 -21.548936,32.88065 -29.5122232,16.22425 L 38.501003,257.53695",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 c 0,0 -2.221794,43.32887 -17.445813,31.80045 l 17.445813,-31.80045",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 c 0,0 19.188645,37.67914 0.38735,35.56212 l -0.38735,-35.56212",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 c 0,0 36.413015,23.58778 18.817165,31.00917 L 38.501003,257.53695",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2397"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 c 0,0 39.495945,2.22179 28.988455,17.44592 L 38.501003,257.53695",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 c 0,0 41.071805,-21.14762 38.052025,-1.82457 l -38.052025,1.82457",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2401"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 c 0,0 25.649765,-39.98383 32.522235,-21.4383 l -32.522235,21.4383",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 c 0,0 16.257764,-38.78651 26.821694,-23.13164 l -26.821694,23.13164",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 c 0,0 -5.550958,-43.02972 11.487502,-34.40501 l -11.487502,34.40501",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 c 0,0 -23.938619,-31.67698 -5.50404,-33.47544 l 5.50404,33.47544",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2409"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 c 0,0 -40.0402882,-16.70791 -24.051613,-27.15119 l 24.051613,27.15119",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2411"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 c 0,0 -43.0295292,5.55025 -34.4050762,-11.48786 l 34.4050762,11.48786",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2413"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 c 0,0 -31.3779252,23.68409 -33.2555142,5.31812 l 33.2555142,-5.31812",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2415"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 c 0,0 -16.707768,40.03921 -27.150801,24.05133 l 27.150801,-24.05133",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 c 0,0 5.353402,41.94316 -11.632037,33.60808 l 11.632037,-33.60808",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 c 0,0 26.321804,34.48861 7.253462,35.53918 l -7.253462,-35.53918",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2421"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 c 0,0 36.431364,15.41497 21.404084,26.20221 L 38.433624,257.20499",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2423"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 c 0,0 45.797964,-6.05296 36.436654,11.11885 L 38.433624,257.20499",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 c 0,0 37.634334,-28.9874 37.847764,-9.21068 l -37.847764,9.21068",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.567326,257.51084 c 0,0 0,-2.6e-4 0,-10e-4 v 7.9e-4 2.6e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.639999,257.38243 c -0.02328,-0.031 -0.04304,-0.0575 -0.06068,-0.0808 2.64e-4,-0.002 2.64e-4,-0.004 7.93e-4,-0.007 l 0.06456,0.0794 -0.0046,0.008",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.695032,257.28471 c -0.0448,-0.0194 -0.0822,-0.0356 -0.111479,-0.048 0,-0.003 2.65e-4,-0.006 7.94e-4,-0.01 l 0.122414,0.0374 -0.01164,0.0201",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.708791,257.17041 0.01093,-0.0201 0.03916,-0.01 c -0.0056,0.009 -0.01093,0.0169 -0.01659,0.0254 -0.0113,0.001 -0.02294,0.003 -0.03351,0.004",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.586728,257.18558 c 0,-0.001 0,-0.002 2.65e-4,-0.003 l 0.132643,-0.0324 -0.01093,0.0201 c -0.04657,0.006 -0.08714,0.0106 -0.122063,0.0152",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.742303,257.16618 c 0.0056,-0.008 0.01093,-0.0166 0.01659,-0.0254 l 0.02045,-0.005 -0.01553,0.0275 c -0.0071,0.001 -0.01447,0.002 -0.02151,0.003",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.586376,257.19229 c 0,-0.002 2.65e-4,-0.005 2.65e-4,-0.007 0.03493,-0.005 0.0755,-0.01 0.122062,-0.0152 0.01058,-0.001 0.02222,-0.003 0.03351,-0.004 0.0071,-10e-4 0.01447,-0.002 0.02151,-0.003 l -0.0039,0.007 c -0.07303,0.009 -0.131585,0.0166 -0.173567,0.0219",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.589903,257.1376 c 0,-0.003 2.65e-4,-0.006 2.65e-4,-0.009 l 0.377118,-0.32526 -0.04763,0.0843 c -0.149225,0.11253 -0.26035,0.19685 -0.329848,0.24976",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.529668,236.28562 4.19312,-7.40904 c 0.0124,0.009 0.0243,0.018 0.0363,0.0268 l -4.07424,7.19843 c -0.0511,0.06 -0.10442,0.12277 -0.15522,0.1838",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.743361,256.48849 9.67599,-28.97892 c 0.581377,-0.23566 1.195917,-0.36125 1.845379,-0.36125 1.333148,0 2.813408,0.52917 4.458058,1.72826 l -4.19312,7.40904 c -5.711473,6.80049 -10.544175,17.37289 -11.786307,20.20287",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.600134,256.9785 c 0.0019,-0.025 0.0035,-0.0515 0.0053,-0.078 l 0.137935,-0.41205 c 1.242132,-2.82998 6.074834,-13.40238 11.786309,-20.20287 0.0508,-0.061 0.10407,-0.12383 0.15522,-0.1838 l -0.954264,1.68593 c -5.669492,6.75181 -10.407298,17.50871 -11.130492,19.19075",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2449"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.531695,257.33481 c -0.0046,-0.006 -0.0088,-0.0116 -0.01304,-0.0169 -2.65e-4,-0.004 -7.94e-4,-0.007 -0.0011,-0.01 l 0.0113,0.0138 0.0028,0.013",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.511941,257.2385 c -0.0011,-2.6e-4 -0.0021,-7.9e-4 -0.0028,-10e-4 -7.94e-4,-0.004 -0.0011,-0.007 -0.0013,-0.01 l 0.0021,2.6e-4 0.0021,0.0102",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.567326,257.51084 c 0,0 -0.0113,-0.0222 -0.03316,-0.0653 -0.006,-0.0505 -0.01093,-0.0928 -0.01553,-0.1277 0.0042,0.005 0.0085,0.0109 0.01304,0.0169 l 0.03563,0.17462 v 10e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.528874,257.32175 -0.0113,-0.0137 c -0.0035,-0.0296 -0.0063,-0.0533 -0.0085,-0.0706 7.94e-4,2.7e-4 0.0019,8e-4 0.0028,10e-4 l 0.01693,0.0832",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.509824,257.22827 -0.0021,-2.6e-4 c -0.0021,-0.0166 -0.0032,-0.0251 -0.0032,-0.0251 v 0 l 0.0053,0.0254",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.481953,257.26884 c -0.0011,-0.001 -0.0021,-0.003 -0.0032,-0.004 2.65e-4,-10e-4 7.94e-4,-0.002 0.0011,-0.003 l 0.0032,0.004 -0.0011,0.003 m -0.04128,-0.01 c 0,0 -2.65e-4,-7.9e-4 -2.65e-4,-0.001 -2.64e-4,-0.002 -7.93e-4,-0.004 -0.0011,-0.007 0.0013,-7.9e-4 0.0021,-10e-4 0.0032,-0.002 l 0.0019,0.007 -0.0035,0.003 m 0.02045,-0.018 c -0.0011,-10e-4 -0.0021,-0.002 -0.0028,-0.004 2.65e-4,0 7.94e-4,-2.7e-4 0.0011,-8e-4 l 0.0028,0.004 -0.0011,10e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.494653,257.23109 v 0 l -2.65e-4,-0.004 c 7.94e-4,-10e-4 0.0011,-0.002 0.0013,-0.003 l 0.0013,2.6e-4 -0.0024,0.007",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.494653,257.23109 c -7.94e-4,-2.6e-4 -0.0011,-2.6e-4 -0.0019,-7.9e-4 7.94e-4,-10e-4 0.0011,-0.002 0.0013,-0.003 l 2.64e-4,0.004 m -0.01482,-0.006 c -0.0011,-2.6e-4 -0.0021,-7.9e-4 -0.0028,-10e-4 0.0019,-0.001 0.0032,-0.002 0.0049,-0.004 l 0.0024,7.9e-4 -0.0046,0.004 m -0.06068,-0.008 c 0,-2.6e-4 0,-2.6e-4 0,-7.9e-4 0.0013,-10e-4 0.0024,-0.002 0.0039,-0.003 7.94e-4,0 0.0011,-2.7e-4 0.0019,-2.7e-4 l -0.0039,0.004 -0.0019,2.6e-4 m 0.01024,-0.002 c 7.94e-4,-10e-4 0.0011,-0.002 0.0013,-0.003 0,0 0,0 2.64e-4,0 l -0.0011,0.003 h -7.94e-4 m 0.0053,-7.9e-4 c 0,-10e-4 -2.65e-4,-0.002 -2.65e-4,-0.002 2.65e-4,0 2.65e-4,0 7.94e-4,0 l 2.65e-4,0.002 -7.94e-4,2.7e-4 m 0.0049,-10e-4 c -2.65e-4,-7.9e-4 -0.0011,-0.001 -0.0013,-0.002 0,0 2.64e-4,0 2.64e-4,-2.7e-4 l 0.0013,0.002 h -2.64e-4 m 0.0095,-0.001 c -0.0013,-2.7e-4 -0.0024,-10e-4 -0.0035,-10e-4 0.0011,0 0.0024,-2.6e-4 0.0035,-2.6e-4 l 0.0039,0.001 -0.0039,7.9e-4 m 0.04057,-0.0138 -0.01093,-0.004 0.0032,-7.9e-4 c 0.0039,0.002 0.0071,0.003 0.01024,0.004 -7.94e-4,0 -0.0019,0 -0.0024,2.7e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.499241,257.19652 -0.0056,-0.006 0.0013,-2.6e-4 c 0.0019,0.002 0.0035,0.005 0.0049,0.006 -2.65e-4,0 -7.94e-4,0 -7.94e-4,0 m 0.0042,-2.7e-4 -0.0011,-0.008 h 2.65e-4 c 2.64e-4,0.003 7.93e-4,0.006 0.0011,0.008 h -2.65e-4 m 0.01058,-10e-4 0.0081,-0.007 c 0,7.9e-4 0,10e-4 -2.64e-4,0.002 -0.0024,0.002 -0.0046,0.004 -0.0063,0.005 -2.65e-4,2.6e-4 -0.0011,2.6e-4 -0.0013,2.6e-4",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.521818,257.18946 c 2.64e-4,-2.6e-4 2.64e-4,-10e-4 2.64e-4,-0.002 l 0.0067,-0.006 0.0042,-0.001 c -0.0042,0.003 -0.0078,0.006 -0.0113,0.008",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.457259,257.18699 -0.0019,-7.9e-4 0.0032,-0.003 c 7.94e-4,2.6e-4 0.0013,7.9e-4 0.0021,10e-4 -0.0013,7.9e-4 -0.0024,0.002 -0.0035,0.002 m -0.0141,-0.005 -0.0019,-7.9e-4 0.0019,-0.005 c 7.93e-4,2.7e-4 0.0011,7.9e-4 0.0021,10e-4 -7.93e-4,0.001 -0.0013,0.003 -0.0021,0.005 m -0.01304,-0.005 -0.0011,-2.7e-4 -0.0011,-0.007 c 2.65e-4,2.6e-4 0.0011,7.9e-4 0.0013,7.9e-4 0,0.002 2.65e-4,0.005 7.94e-4,0.007 m 0.04692,-0.006 -0.0021,-0.002 0.0028,-0.002 c 7.94e-4,0.001 0.0013,0.002 0.0021,0.003 -0.0011,7.9e-4 -0.0019,10e-4 -0.0028,0.002 m -0.0695,-10e-4 -0.0067,-0.002 -0.0127,-0.0145 c 0,0 0,0 0,-2.6e-4 0.0035,0.002 0.0067,0.003 0.0099,0.004 0.0035,0.005 0.0067,0.009 0.0095,0.0127",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.497124,257.15665 -0.0011,-0.006 0.0019,-10e-4 c 2.64e-4,0.002 7.94e-4,0.004 7.94e-4,0.006 -2.65e-4,2.7e-4 -0.0011,0.001 -0.0013,0.001",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.457259,257.14925 -0.0035,-0.004 0.0021,-0.007 c 0.0013,0.002 0.0028,0.004 0.0039,0.005 -7.93e-4,0.002 -0.0019,0.004 -0.0024,0.006 m -0.03563,-0.0402 -0.0046,-0.005 -0.0039,-0.0233 c 0.0019,0.003 0.0039,0.005 0.0056,0.008 0.0011,0.007 0.0019,0.0145 0.0028,0.0208 m 0.0635,-0.0254 -0.0035,-0.0219 0.0039,-0.0124 c 0.0011,0.009 0.0021,0.0177 0.0032,0.0257 -0.0011,0.003 -0.0024,0.006 -0.0035,0.008",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.999353,234.55771 -0.233892,-10.71104 c 0.02257,0.002 0.04445,0.005 0.06703,0.008 l 0.223308,10.23373 c -0.01939,0.15557 -0.0381,0.31256 -0.05645,0.46919",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.270993,255.78082 -4.874332,-29.64674 c -0.024,0.002 -0.04657,0.005 -0.07055,0.007 l -0.266348,-1.62172 c 0.8636,-0.49177 1.950509,-0.762 3.29565,-0.762 0.441677,0 0.911577,0.0293 1.410052,0.0893 l 0.233892,10.71104 c -0.935567,8.1019 -0.105127,17.66782 0.27164,21.22311",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.455495,257.18629 -0.01236,-0.004 c 7.93e-4,-0.001 0.0013,-0.003 0.0021,-0.005 0.0046,0.002 0.0092,0.004 0.01341,0.006 l -0.0032,0.003 m 0.01939,-0.0169 -0.01765,-0.0201 c 7.94e-4,-0.002 0.0019,-0.004 0.0024,-0.006 0.0067,0.009 0.0127,0.0169 0.01799,0.0236 l -0.0028,0.002 m 0.02117,-0.0183 -0.01093,-0.0674 c 0.0011,-0.003 0.0024,-0.006 0.0035,-0.008 0.0039,0.03 0.0067,0.055 0.0092,0.0744 l -0.0019,0.001",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.441384,257.1817 -0.0113,-0.004 c -2.65e-4,-0.002 -7.94e-4,-0.004 -7.94e-4,-0.007 0.0046,0.002 0.0092,0.004 0.01376,0.006 l -0.0019,0.005 m 0.01236,-0.0363 -0.0321,-0.0363 c -0.0011,-0.006 -0.0019,-0.0138 -0.0028,-0.0208 0.0141,0.0187 0.02646,0.0356 0.03704,0.0497 l -0.0021,0.007 m 0.02787,-0.0836 -0.210608,-1.28094 c -0.376767,-3.55529 -1.207207,-13.12121 -0.27164,-21.22311 0.01834,-0.15663 0.03704,-0.31362 0.05645,-0.46919 l 0.04586,2.09656 c -1.016707,8.80286 0.213431,19.46804 0.383823,20.86433 l -0.0039,0.0124",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.429036,257.17747 -0.02151,-0.007 c -0.0028,-0.004 -0.006,-0.008 -0.0095,-0.0127 0.01093,0.005 0.02082,0.009 0.02999,0.0127 l 0.0011,0.007 m -0.01199,-0.0737 -0.121357,-0.13653 c -0.02117,-0.043 -0.04339,-0.0885 -0.06703,-0.13652 0.07691,0.10477 0.138994,0.18838 0.184502,0.24976 l 0.0039,0.0233 m -7.301818,-30.51775 c 0.452612,-0.87489 1.089025,-1.57938 1.94451,-2.06657 l 0.266348,1.62172 c -0.826912,0.085 -1.562454,0.23566 -2.210858,0.44485",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.400816,257.1683 -0.0067,-0.002 c -0.0019,-0.004 -0.0039,-0.008 -0.006,-0.012 l 0.0127,0.0145",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.419159,257.21592 c -2.64e-4,-7.9e-4 -7.93e-4,-10e-4 -0.0011,-0.002 0.0013,-2.6e-4 0.0032,-2.6e-4 0.0049,-7.9e-4 -0.0013,0.001 -0.0024,0.002 -0.0039,0.003",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.420924,257.21628 0.0039,-0.004 c 0.0021,0 0.0039,-2.7e-4 0.006,-8e-4 -2.65e-4,0.001 -7.94e-4,0.002 -0.0013,0.003 l -0.0085,0.001",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2491"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.440326,257.25825 c -0.0011,-0.002 -0.0019,-0.004 -0.0028,-0.005 7.94e-4,-2.6e-4 0.0013,-7.9e-4 0.0019,-10e-4 2.65e-4,0.002 7.94e-4,0.005 0.0011,0.007 m -0.01024,-0.0434 0.0011,-0.003 c 0.0011,0 0.0021,-2.6e-4 0.0032,-2.6e-4 0,7.9e-4 2.65e-4,0.001 2.65e-4,0.002 l -0.0046,7.9e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.466784,257.31188 c -0.0013,-0.003 -0.0028,-0.006 -0.0042,-0.009 0.006,-0.0141 0.0113,-0.0268 0.01622,-0.0381 0.0011,0.001 0.0021,0.003 0.0032,0.004 l -0.01516,0.043 m -0.02257,-0.0554 -0.0019,-0.007 c 0.0056,-0.004 0.01093,-0.008 0.01588,-0.012 7.94e-4,0.001 0.0019,0.002 0.0028,0.004 l -0.01693,0.0152 m -0.0088,-0.0427 -2.64e-4,-0.002 c 0.0011,-2.6e-4 0.0021,-2.6e-4 0.0032,-2.6e-4 2.64e-4,2.6e-4 0.0011,0.001 0.0013,0.002 l -0.0042,7.9e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.483011,257.26566 -0.0032,-0.004 c 0.0053,-0.0123 0.0095,-0.0229 0.01304,-0.0314 7.94e-4,2.6e-4 0.0011,2.6e-4 0.0019,7.9e-4 v 0 l -0.01164,0.0346 m -0.02082,-0.0254 -0.0028,-0.004 c 0.0067,-0.005 0.01236,-0.009 0.01765,-0.013 7.93e-4,2.6e-4 0.0019,7.9e-4 0.0028,10e-4 l -0.01765,0.0155 m -0.02222,-0.0272 -0.0013,-0.002 c 0.0024,0 0.0049,-2.7e-4 0.0071,-8e-4 0.0011,2.7e-4 0.0021,0.001 0.0035,0.001 l -0.0092,10e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.497124,257.22439 -0.0013,-2.7e-4 c 0.006,-0.0141 0.0088,-0.0212 0.0088,-0.0212 l -0.02011,0.0176 -0.0024,-7.9e-4 c 0.01482,-0.0113 0.02257,-0.0169 0.02257,-0.0169 l -0.05151,0.008 -0.0039,-10e-4 c 0.03669,-0.005 0.05539,-0.007 0.05539,-0.007 l -0.01482,-0.005 c 7.93e-4,-2.6e-4 0.0019,-2.6e-4 0.0024,-2.6e-4 0.0081,0.004 0.01236,0.005 0.01236,0.005 v 0 0 l -0.0053,-0.006 c 0,0 2.65e-4,0 7.94e-4,0 0.0032,0.004 0.0046,0.006 0.0046,0.006 v 0 0 l -0.0011,-0.007 h 2.65e-4 c 2.64e-4,0.004 7.93e-4,0.007 7.93e-4,0.007 v 0 l 0.0095,-0.008 c 2.65e-4,0 0.0011,0 0.0013,-2.6e-4 -0.0074,0.006 -0.01093,0.008 -0.01093,0.008 v 0 0 0 0 0 0 l -0.0074,0.0215",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.478778,257.19405 -0.02151,-0.007 c 0.0011,-8e-4 0.0021,-0.002 0.0035,-0.002 0.0081,0.003 0.01516,0.006 0.02117,0.009 l -0.0032,7.9e-4 m 0.01482,-0.004 -0.01659,-0.0187 c 0.0011,-7.9e-4 0.0019,-0.001 0.0028,-0.002 0.0064,0.008 0.0113,0.0152 0.01516,0.0205 l -0.0013,2.7e-4 m 0.0088,-0.002 -0.0053,-0.0317 c 2.65e-4,-2.7e-4 0.0011,-0.001 0.0013,-0.001 0.0019,0.0141 0.0032,0.025 0.0042,0.0332 h -2.64e-4 m 0.02646,-0.006 0.03069,-0.0265 v 0.005 c -0.01024,0.008 -0.01905,0.0148 -0.02646,0.0204 l -0.0042,0.001",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2501"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.545807,257.25332 c -0.0013,-8e-4 -0.0028,-10e-4 -0.0042,-0.002 -0.0049,-0.006 -0.0092,-0.012 -0.01341,-0.0173 l 0.0024,8e-4 0.01516,0.0187",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2503"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.562034,257.27872 c -0.0074,-0.01 -0.01447,-0.0194 -0.02045,-0.0275 0.0013,7.9e-4 0.0028,0.001 0.0042,0.002 l 0.01622,0.0198 v 0.006",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.530636,257.23462 -0.0024,-7.9e-4 c -0.01553,-0.0205 -0.02363,-0.031 -0.02363,-0.031 v 0 l 0.02611,0.0317 m 0.03034,-0.008 c -0.03704,-0.0159 -0.05644,-0.024 -0.05644,-0.024 v 0 l 0.05644,0.0173 v 0.007",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2507"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.507001,257.19546 0.0032,-0.009 0.0013,-2.6e-4 c -0.0013,0.004 -0.0028,0.007 -0.0039,0.009 -2.65e-4,0 -2.65e-4,0 -7.94e-4,0",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.527816,257.13302 0.0046,-0.013 0.01164,-0.01 c -0.0024,0.005 -0.0046,0.0109 -0.0067,0.0159 -0.0032,0.002 -0.0063,0.005 -0.0095,0.007",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.532401,257.11997 0.02469,-0.0744 7.93e-4,0.0321 c -0.0049,0.0117 -0.0095,0.0222 -0.01376,0.0325 l -0.01164,0.01",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2513"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.504532,257.20287 0.0024,-0.007 c 2.64e-4,0 2.64e-4,0 7.93e-4,0 -0.0021,0.005 -0.0032,0.007 -0.0032,0.007",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.510176,257.18664 0.01765,-0.0536 c 0.0032,-0.002 0.0063,-0.005 0.0095,-0.007 -0.01164,0.0272 -0.02011,0.0473 -0.02574,0.0603 l -0.0013,2.6e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.504532,257.20287 0.05574,-0.0134 v 0.006 c -0.03669,0.005 -0.05574,0.007 -0.05574,0.007",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2519"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.567326,257.51084 c 0,0 -0.0095,-0.006 -0.02752,-0.018 -0.0019,-0.0141 -0.0032,-0.0272 -0.0049,-0.0402 l 0.03246,0.0582",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.451968,257.35492 c -7.94e-4,-0.007 -0.0019,-0.0145 -0.0024,-0.0215 0.0024,-0.006 0.0046,-0.0109 0.0071,-0.0162 l 0.0032,0.0155 -0.0078,0.0222",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.429743,257.41948 c -0.0042,-0.002 -0.0088,-0.006 -0.01342,-0.008 0.01236,-0.0289 0.02328,-0.0547 0.03316,-0.0776 7.94e-4,0.007 0.0019,0.0141 0.0024,0.0215 l -0.02222,0.0646",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.459728,257.33269 -0.0032,-0.0155 c 2.65e-4,-10e-4 7.94e-4,-0.002 0.0013,-0.004 l 0.0049,0.01 -0.0032,0.01",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.392701,257.302 c 0.0035,-0.008 0.0067,-0.0159 0.0095,-0.0229 0.0028,-0.002 0.0049,-0.004 0.0078,-0.005 l -0.0067,0.0187 -0.01058,0.01",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.332728,257.35492 c -0.0056,-0.004 -0.0113,-0.007 -0.01693,-0.0113 0.03316,-0.0247 0.06209,-0.0462 0.08643,-0.0646 -0.0028,0.007 -0.006,0.0148 -0.0095,0.0229 l -0.05997,0.0529",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.403284,257.29248 0.0067,-0.0187 c 0.006,-0.005 0.01236,-0.01 0.01799,-0.0138 l 0.0039,0.007 -0.02858,0.0254",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.172216,257.24697 c -0.0013,-10e-4 -0.0032,-0.002 -0.0046,-0.003 0.03281,-0.004 0.06315,-0.007 0.09102,-0.0106 l -0.08643,0.0138",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.183151,257.25438 c -0.0039,-0.002 -0.0071,-0.005 -0.01093,-0.007 l 0.08643,-0.0138 c 0.05821,-0.007 0.106539,-0.013 0.144639,-0.0177 l 0.0019,0.003 -0.221898,0.0356",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.146816,257.08328 -0.420865,-0.14041 c -0.05292,-0.0363 -0.10795,-0.0741 -0.1651,-0.11359 0.244123,0.10689 0.441325,0.19191 0.585965,0.254",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.371534,257.15842 -0.224718,-0.0751 c -0.14464,-0.0621 -0.341842,-0.14711 -0.585965,-0.254 -0.0441,-0.0307 -0.08925,-0.0617 -0.135819,-0.0942 0.445204,0.19685 0.766586,0.33514 0.937684,0.40781 l 0.0088,0.0155",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.064266,256.7058 -0.06632,-0.0751 -0.0381,-0.0681 c 0.03704,0.0508 0.07161,0.0981 0.104423,0.14322 m -10.878468,-19.5393 -3.971643,-7.14974 c 0.02162,-0.0106 0.04202,-0.0201 0.06378,-0.0303 l 3.788375,6.81954 c 0.03888,0.11995 0.07881,0.24025 0.119486,0.36054",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37.997943,256.63066 18.930798,235.10628 c 0.209303,-1.98649 1.483713,-3.74932 4.283357,-5.08952 l 3.971643,7.14974 c 2.69046,7.96537 8.996751,16.95098 10.774045,19.39608 l 0.0381,0.0681",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.213843,256.87443 -0.149577,-0.16863 c -0.03281,-0.0452 -0.06738,-0.0924 -0.104423,-0.14322 -1.777294,-2.4451 -8.083585,-11.43071 -10.774045,-19.39608 -0.04068,-0.12029 -0.08061,-0.24059 -0.119486,-0.36054 l 0.999208,1.79917 c 2.496925,7.39175 8.34845,15.73001 9.998746,18.00049 l 0.149577,0.26881",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.567326,257.51084 c 0,0 -0.0088,-2.6e-4 -0.02574,-10e-4 -2.65e-4,-0.005 -0.0011,-0.009 -0.0013,-0.0134 l 0.02717,0.0148",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2549"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.401168,257.50167 c -0.0074,-7.9e-4 -0.01516,-10e-4 -0.02294,-10e-4 0.01164,-0.0272 0.02222,-0.0522 0.03211,-0.0755 l 0.01482,0.008 -0.024,0.0688",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.182445,257.48827 c -0.01871,-10e-4 -0.03845,-0.002 -0.05856,-0.004 0.06421,-0.0473 0.12065,-0.0886 0.168982,-0.12453 l 0.02117,0.0116 -0.131587,0.11642",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.017699,257.27166 -0.01516,-0.008 c 0.02611,-0.003 0.05186,-0.006 0.07585,-0.009 0.0028,0.002 0.006,0.004 0.0088,0.006 l -0.0695,0.0113",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.087195,257.26037 c -0.0028,-0.002 -0.006,-0.004 -0.0088,-0.006 0.006,-8e-4 0.01164,-10e-4 0.01765,-0.002 l 0.0095,0.005 -0.01834,0.003",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2557"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.122701,257.41489 c -0.09631,-0.007 -0.197202,-0.0152 -0.301977,-0.0233 0.497062,-0.0508 0.89676,-0.0952 1.181804,-0.12841 l 0.01516,0.008 -0.894999,0.14323",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.161153,257.41771 c -0.01304,-10e-4 -0.0254,-0.002 -0.03845,-0.003 l 0.894998,-0.14323 0.0695,-0.0113 0.01834,-0.003 0.0127,0.007 -0.957088,0.15311",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.230299,256.77742 -0.290338,-0.097 -1.330677,-0.72989 c 0.240948,0.11077 0.468842,0.21519 0.683332,0.31256 l 0.937683,0.51435 M 20.93514,247.90014 9.0196478,241.36317 c 0.01104,-0.0148 0.02205,-0.0293 0.03309,-0.0441 l 11.3969092,6.25228 c 0.160549,0.10971 0.323427,0.22014 0.485493,0.32879",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.939961,256.6804 7.3452238,246.7991 c -0.33528,-1.57621 0.128411,-3.37749 1.674424,-5.43595 l 11.9154922,6.53697 c 5.254202,3.52213 11.240911,6.46712 14.674144,8.05039 l 1.330677,0.72989",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.292616,256.26307 c -0.21449,-0.0974 -0.442384,-0.20179 -0.683332,-0.31256 -3.433233,-1.58327 -9.419942,-4.52826 -14.674144,-8.05039 -0.162066,-0.10865 -0.324944,-0.21908 -0.485493,-0.32879 l 1.815853,0.99625 c 4.874966,3.26742 10.429486,6.00039 13.616128,7.46971 l 0.410988,0.22578",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4.9077408,258.27038 c 0.0011,-0.009 0.0019,-0.0159 0.003,-0.0243 l 14.3156162,-0.31291 c 0.103469,0.006 0.209585,0.012 0.313231,0.0177 l -14.6318812,0.31961 m 29.3098342,-0.63994 c 0.133702,-0.0113 0.263525,-0.0222 0.39229,-0.0332 l 1.588558,-0.0346 -0.178154,0.0282 -1.802694,0.0395",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5.3186558,262.50053 c -0.465208,-1.08938 -0.626321,-2.4832 -0.410915,-4.23015 l 14.6318812,-0.31962 c 1.544073,0.0832 3.097953,0.11818 4.61779,0.11818 3.827921,0 7.431616,-0.22049 10.060164,-0.4385 l 1.802694,-0.0395 -30.7016142,4.9096",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.157412,258.06894 c -1.519837,0 -3.073717,-0.0349 -4.61779,-0.11818 -0.103646,-0.006 -0.209762,-0.0116 -0.313232,-0.0177 l 1.745686,-0.0381 c 1.432066,0.0773 2.872952,0.10936 4.282546,0.10936 3.55145,0 6.895323,-0.20426 9.334781,-0.40675 l 0.02045,-2.6e-4 c -0.128765,0.0109 -0.258588,0.0219 -0.39229,0.0332 -2.628548,0.21801 -6.232242,0.4385 -10.060164,0.4385",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.4579898,265.3157 c -1.444766,-0.51611 -2.54194,-1.41605 -3.139334,-2.81517 l 30.7016142,-4.9096 0.178154,-0.0282 0.06562,-10e-4 -28.6240722,4.57764 c 0.129399,1.26612 0.409681,2.31634 0.818021,3.17677",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.054261,258.25238 c 0.0063,-0.004 0.01341,-0.009 0.01939,-0.0138 0.152752,-0.0734 0.294921,-0.14218 0.425096,-0.20532 l -0.01341,0.0116 c -0.132291,0.0642 -0.276579,0.1337 -0.431096,0.20743 m 0.98425,-0.70555 c 0.01164,-0.008 0.02328,-0.0169 0.03457,-0.0251 l 0.0032,-2.6e-4 -0.02822,0.0254 h -0.0095",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.073666,258.23863 c 0.400754,-0.28293 0.726016,-0.51753 0.964845,-0.6918 h 0.0095 l -0.549275,0.48648 c -0.130175,0.0631 -0.272343,0.13194 -0.425095,0.20532",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.485357,258.04495 0.01342,-0.0116 0.549275,-0.48648 0.02822,-0.0254 0.0702,-0.001 -0.509762,0.45155 c -0.04833,0.0236 -0.09913,0.0483 -0.151342,0.0734",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.320028,257.63538 c 0.01871,-0.0434 0.03598,-0.0833 0.05186,-0.1203 l 0.02469,-2.7e-4 -0.03422,0.0995 c -0.01376,0.007 -0.02752,0.0138 -0.04233,0.0212",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.543336,257.52319 c -7.93e-4,-0.004 -0.0011,-0.008 -0.0013,-0.0116 l 0.0254,-7.9e-4 c 0,0 -0.0081,0.004 -0.024,0.0123",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.206683,276.89457 c -1.959574,-0.24765 -3.69824,-1.53987 -5.029976,-4.32541 l 8.388385,-4.61151 c 3.732707,-1.37054 7.614779,-3.45334 10.880161,-5.42255 2.439529,-1.44356 4.557958,-2.85502 6.009288,-3.86291 l 0.8509,-0.46743 -21.098758,18.68981",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19.565092,267.95765 1.375692,-0.75635 c 3.237724,-1.18287 6.599308,-2.94711 9.504469,-4.6662 -3.265382,1.96921 -7.147454,4.05201 -10.880161,5.42255",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.267326,276.90198 c -0.02,-0.002 -0.04078,-0.005 -0.06064,-0.007 l 21.098758,-18.68981 0.180268,-0.0995 -21.218383,18.7967",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.020168,258.32047 c 0.03034,-0.0684 0.05927,-0.13406 0.08678,-0.1965 0.0056,-0.009 0.01199,-0.0177 0.01765,-0.0261 l -0.04904,0.14181 c -0.01799,0.0265 -0.03669,0.0533 -0.05539,0.0808",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.106951,258.12397 c 0.0141,-0.0321 0.02787,-0.0635 0.04092,-0.0938 l -0.02328,0.0677 c -0.0056,0.008 -0.01199,0.0173 -0.01765,0.0261",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.075553,258.23968 0.04904,-0.14181 0.02328,-0.0677 c 0.0635,-0.14428 0.118533,-0.27128 0.165804,-0.37994 l 0.04445,-0.0243 -0.140052,0.40534 c -0.04374,0.0642 -0.09137,0.1337 -0.142523,0.20849",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.545453,257.54365 c -7.94e-4,-0.006 -0.0013,-0.0134 -0.0021,-0.0198 l 0.024,-0.013 c 0,0 -0.0074,0.0109 -0.02188,0.0328",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26.869815,288.83575 c -1.342637,0 -2.834922,-0.55422 -4.494072,-1.81081 l 6.791538,-12.37968 c 1.145397,-1.71273 2.22913,-3.50097 3.22467,-5.25321 2.280708,-3.91478 4.116565,-7.74065 5.160785,-10.03195 l 0.365832,-0.66675 -10.418163,30.10077 c -0.206728,0.0275 -0.416313,0.0416 -0.63059,0.0416",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2601"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 29.167281,274.64526 0.478859,-0.87277 c 0.966401,-1.4217 1.887151,-2.90689 2.745811,-4.38044 -0.99554,1.75224 -2.079273,3.54048 -3.22467,5.25321",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2603"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27.500405,288.79412 10.418163,-30.10077 0.190148,-0.34677 -10.399961,30.04819 c 0.175966,0.0864 0.349744,0.16722 0.52063,0.24201 -0.237596,0.0713 -0.480519,0.12382 -0.72898,0.15734",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.558859,257.65936 c -0.0042,-0.0392 -0.0085,-0.0762 -0.0127,-0.11042 l 0.02117,-0.0381 c 0,0 -0.0028,0.0508 -0.0085,0.14852",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2607"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.279357,290.59611 c -0.42545,0 -0.875596,-0.0261 -1.352904,-0.0797 l -0.125235,-11.51573 c 0.290335,-2.48426 0.411691,-5.09905 0.430035,-7.6207 0.113596,-5.84623 -0.411337,-11.34816 -0.632529,-13.36569 l 6.290027,30.81902 c -0.999067,1.11442 -2.491669,1.76283 -4.609394,1.76283",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.801218,279.00065 -0.01199,-1.10631 c 0.268462,-2.11031 0.399696,-4.33669 0.442029,-6.51439 -0.01834,2.52165 -0.1397,5.13644 -0.430035,7.6207",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2611"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 44.888751,288.83328 -6.290027,-30.81902 c -0.01024,-0.0938 -0.01976,-0.18027 -0.02893,-0.25894 l -0.0024,-0.24448 c 0,0 0,2.7e-4 2.65e-4,8e-4 l 6.379281,31.25575 c -0.01939,0.0222 -0.03845,0.0441 -0.05821,0.066 m -6.321404,-31.32246 v 0 0 0",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 56.031588,286.29116 -5.941835,-9.7917 c -1.140883,-2.61973 -2.556227,-5.28461 -4.00191,-7.76287 -2.664532,-4.67713 -5.552723,-8.76724 -6.863644,-10.56358 l 20.583519,25.1975 c -0.67945,1.13489 -1.89547,2.12725 -3.77613,2.92065",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2615"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.089753,276.49946 -0.58279,-0.96026 c -0.965904,-2.27965 -2.167467,-4.60516 -3.41912,-6.80261 1.445683,2.47826 2.861027,5.14314 4.00191,7.76287",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 59.807718,283.37051 -20.583519,-25.1975 c -0.123473,-0.16898 -0.232481,-0.3175 -0.326673,-0.4445 0.02506,0.0166 0.05186,0.0342 0.07937,0.0526 l 19.392902,23.73983 c 0.83573,-0.59972 1.49966,-1.21461 2.00977,-1.8415 0.24342,1.33138 0.0928,2.58022 -0.57185,3.69111",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.567326,257.51084 v 0 c 0,0 0,0 2.65e-4,0 v 8e-4 m -2.65e-4,-8e-4 v 0 0 0",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2621"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.838032,257.63361 c -0.156281,-0.0127 -0.300566,-0.024 -0.431448,-0.0342 -0.02787,-0.0123 -0.05539,-0.0247 -0.0822,-0.0367 0.113948,0.008 0.23989,0.0183 0.377121,0.0293 l 0.136525,0.0416",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2623"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 65.471218,273.70299 -6.21947,-3.74332 c -3.23145,-3.15384 -7.80592,-6.06743 -11.843105,-8.31074 -3.433234,-1.94063 -6.530975,-3.38843 -8.002059,-4.04954 0.130882,0.0102 0.275167,0.0215 0.431448,0.0342 l 25.813806,7.87718 c 1.83092,2.1336 2.14736,4.81894 -0.18062,8.1922",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 59.251748,269.95967 -1.26577,-0.762 c -2.85679,-2.83881 -6.90845,-5.47476 -10.577335,-7.54874 4.037185,2.24331 8.611655,5.1569 11.843105,8.31074",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 65.651838,265.51079 -25.813806,-7.87718 -0.136525,-0.0416 c 0.03528,0.003 0.07055,0.006 0.107244,0.009 l 25.814867,7.87717 c 0.009,0.0109 0.0187,0.0219 0.0282,0.0328",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.938801,257.7345 -0.06597,-0.0399 c -0.04727,-0.0635 -0.08996,-0.121 -0.128412,-0.17286 0.0071,2.6e-4 0.01447,10e-4 0.02188,10e-4 l 0.172508,0.21132",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.567326,257.51084 v 0 0 h 2.65e-4 m -2.65e-4,0 v 0 0 0",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.567326,257.51084 v 0 0 0 0",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.730309,257.50308 c -0.0141,-0.019 -0.02787,-0.0374 -0.04092,-0.0547 0.0039,-0.002 0.0074,-0.004 0.0113,-0.006 l 0.04833,0.0593 -0.01871,10e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.145882,257.48298 c -0.105481,-0.0469 -0.199321,-0.0882 -0.280106,-0.12348 0.0092,-0.005 0.01834,-0.009 0.02787,-0.0141 l 0.424039,0.12947 -0.171802,0.008",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.317684,257.47486 -0.424039,-0.12947 c 0.0095,-0.005 0.01939,-0.01 0.02963,-0.0148 l 0.46214,0.14111 -0.06773,0.003",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.414699,257.0861 c 0.127704,-0.0632 0.269169,-0.13265 0.422979,-0.20779 l 31.60395,-7.69055 c 1.97838,1.06468 2.98803,3.13408 2.44158,6.6301 l -12.452,0.5969 c -2.17805,-0.17497 -4.43477,-0.24447 -6.64386,-0.24447 -6.722187,0 -13.015037,0.64382 -15.372649,0.91581",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.397766,257.09421 c 0.0056,-0.002 0.0113,-0.005 0.01693,-0.008 2.357612,-0.27199 8.650462,-0.91581 15.372642,-0.91581 2.2091,0 4.46581,0.0695 6.64386,0.24447 l -1.41781,0.0681 c -2.07257,-0.17251 -4.22416,-0.2406 -6.3306,-0.2406 -6.255453,0 -12.11015,0.60079 -14.285025,0.85196",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.567326,257.51084 c 0,0 0,0 0,-2.6e-4 v 2.6e-4 0 0",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.680568,257.43605 c -0.01236,-0.0159 -0.024,-0.0317 -0.03493,-0.0462 0.0019,-0.003 0.0035,-0.005 0.0053,-0.008 l 0.03916,0.048 -0.0095,0.006",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.824501,257.34116 c -0.0053,-0.002 -0.01058,-0.005 -0.01587,-0.007 l 0.01516,-0.01 0.01799,0.006 -0.01728,0.0113",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.808626,257.3341 c -0.03598,-0.0155 -0.06914,-0.03 -0.09878,-0.043 2.65e-4,-2.6e-4 7.94e-4,-10e-4 7.94e-4,-10e-4 l 0.113242,0.0346 -0.01516,0.01",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.841786,257.32987 -0.01799,-0.006 -0.113242,-0.0346 c 0.0046,-0.007 0.0088,-0.013 0.01341,-0.0201 l 0.142875,0.0437 -0.02506,0.0166",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.135651,257.11855 0.166865,-0.10971 0.04198,-0.0106 -0.176388,0.11677 c -0.01093,0.001 -0.02188,0.002 -0.03246,0.004",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.795926,257.15948 c 0.0071,-0.0106 0.0141,-0.0215 0.02151,-0.0328 l 0.485071,-0.11783 -0.166865,0.10971 c -0.130881,0.0155 -0.244123,0.0293 -0.339725,0.0409",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.791341,257.16653 c 0.0013,-0.002 0.0028,-0.005 0.0046,-0.007 0.0956,-0.0116 0.208844,-0.0254 0.339725,-0.0409 0.01058,-10e-4 0.02151,-0.002 0.03246,-0.004 l -0.01199,0.007 c -0.144637,0.0173 -0.2667,0.0321 -0.364771,0.0441",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2661"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 57.120968,245.26275 11.62473,-7.66304 c 0.002,0.005 0.004,0.009 0.005,0.0145 l -11.5129,7.58896 c -0.0392,0.0201 -0.078,0.0395 -0.11712,0.0596",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.096845,256.70404 c 0.0063,-0.01 0.01236,-0.0187 0.01871,-0.0282 l 24.282403,-20.94159 c -0.008,-0.0127 -0.0166,-0.025 -0.0251,-0.0374 l 1.88242,-1.62348 c -0.22049,-0.32667 -0.44344,-0.62971 -0.66851,-0.91017 1.71203,0.36724 3.15136,1.7272 4.15889,4.43653 l -11.62473,7.66304 c -7.895873,4.0192 -15.738827,9.73279 -18.024123,11.44129",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 63.372898,235.69683 c -0.65299,-0.96096 -1.32821,-1.69792 -2.02177,-2.23767 0.77082,-0.26035 1.51306,-0.4004 2.22003,-0.4004 0.34749,0 0.68686,0.0342 1.01565,0.10442 0.22507,0.28046 0.44802,0.5835 0.66851,0.91017 l -1.88242,1.62348",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.029466,256.80564 c 0.02151,-0.0328 0.04409,-0.0667 0.06738,-0.1016 2.285296,-1.7085 10.12825,-7.42209 18.024122,-11.44129 0.0392,-0.0201 0.078,-0.0395 0.11712,-0.0596 l -1.38959,0.91617 c -7.437261,3.78566 -14.823721,9.19056 -16.819031,10.68634",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.558507,257.10974 -2.64e-4,-0.012 0.03634,-0.0314 c -2.65e-4,0.006 -7.94e-4,0.0113 -0.0011,0.0169 -0.01236,0.009 -0.024,0.018 -0.03493,0.0265",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.558153,257.09774 -2.65e-4,-0.0201 c 0.01199,-0.0286 0.02646,-0.0617 0.04233,-0.0991 -0.0019,0.0307 -0.0039,0.0596 -0.0056,0.0878 l -0.03634,0.0314",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.559566,257.1556 -0.0011,-0.0459 c 0.01093,-0.008 0.02257,-0.0173 0.03493,-0.0265 -0.0011,0.0155 -0.0021,0.0307 -0.0032,0.0455 l -0.03069,0.0268",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2675"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.970199,256.79859 0.06244,-0.11007 0.05927,-0.0512 c -0.03175,0.0476 -0.06244,0.0938 -0.09172,0.13793 l -0.0078,0.007 c -0.0074,0.005 -0.01482,0.0109 -0.02222,0.0162",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.000184,256.7753 c 0.02928,-0.0441 0.05997,-0.0903 0.09172,-0.13793 l 0.116063,-0.10019 c -0.0321,0.048 -0.06279,0.0942 -0.09243,0.13864 l -0.115359,0.0995",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.032641,256.68852 10.697985,-18.90077 c 2.692042,-3.20605 5.594352,-5.50828 8.377772,-5.50828 1.10701,0 2.19427,0.36372 3.24273,1.17969 -8.16646,2.75837 -19.369971,18.92371 -22.143158,23.07802 l -0.116063,0.10019 -0.05927,0.0512",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2681"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.967376,256.80353 0.0028,-0.005 c 0.0074,-0.005 0.01482,-0.0109 0.02222,-0.0162 l -0.02506,0.0212",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.880945,256.86597 0.05151,-0.091 0.10019,-0.0864 -0.06244,0.11007 c -0.03105,0.0233 -0.06068,0.0459 -0.08925,0.0674",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.593432,257.08328 c 2.65e-4,-0.006 7.94e-4,-0.0113 0.0011,-0.0169 l 0.33796,-0.29139 -0.05151,0.091 c -0.118886,0.0892 -0.215194,0.16227 -0.287513,0.21731",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.594491,257.06634 c 0.0019,-0.0282 0.0039,-0.0571 0.0056,-0.0878 0.723194,-1.68204 5.461,-12.43894 11.130492,-19.19075 l -10.697985,18.90077 -0.10019,0.0864 -0.33796,0.29139",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.590257,257.12879 c 0.0011,-0.0148 0.0021,-0.03 0.0032,-0.0455 0.07232,-0.055 0.168627,-0.12806 0.287513,-0.21731 0.02857,-0.0215 0.05821,-0.0441 0.08925,-0.0674 l -0.0028,0.005 -0.377118,0.32526",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.507707,257.19546 c 0.0011,-0.002 0.0024,-0.006 0.0039,-0.009 l 0.01093,-0.003 c -2.64e-4,0.002 -2.64e-4,0.003 -2.64e-4,0.004 l -0.0081,0.007 c -0.0021,2.6e-4 -0.0042,2.6e-4 -0.0063,7.9e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.52217,257.1877 c 0,-0.001 0,-0.002 2.64e-4,-0.004 l 0.0063,-10e-4 -0.0067,0.006 m 0.01516,-0.0617 c 0.0021,-0.005 0.0042,-0.0106 0.0067,-0.0159 l 0.0141,-0.0124 2.65e-4,0.012 c -0.0074,0.006 -0.01447,0.0109 -0.02117,0.0162",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.544043,257.11009 c 0.0042,-0.0102 0.0088,-0.0208 0.01376,-0.0325 l 2.65e-4,0.0201 -0.0141,0.0124",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.504532,257.20287 v 0 c 0,0 0.0011,-0.002 0.0032,-0.007 0.0021,-2.6e-4 0.0042,-2.6e-4 0.0063,-7.9e-4 l -0.0095,0.008",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.511586,257.18629 c 0.0056,-0.013 0.0141,-0.0332 0.02574,-0.0603 0.0067,-0.005 0.01376,-0.0106 0.02117,-0.0162 l 0.0011,0.0459 -0.03069,0.0265 -0.0063,0.001 -0.01093,0.003",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2701"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.115543,256.67582 c 0.02963,-0.0445 0.06032,-0.0907 0.09243,-0.13864 l 24.164925,-20.84035 c 0.008,0.0123 0.0169,0.0247 0.0251,0.0374 l -24.282403,20.94159",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.20797,256.53718 c 2.773187,-4.15431 13.976698,-20.31965 22.143158,-23.07802 0.69356,0.53975 1.36878,1.27671 2.02177,2.23767 L 39.20797,256.53718",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.554274,256.92206 -0.0013,-0.0741 0.07126,-0.21379 c -0.0035,0.0526 -0.0074,0.10301 -0.01058,0.15134 -0.02151,0.0498 -0.04127,0.0953 -0.05927,0.13653 m 9.782879,-29.37828 0.769056,-2.30293 c 0.02011,0.0102 0.04022,0.0205 0.06068,0.0307 l -0.747535,2.23803 c -0.02752,0.0113 -0.05468,0.0226 -0.0822,0.0342",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.557095,257.04553 -0.0028,-0.12347 c 0.01799,-0.0413 0.03775,-0.0868 0.05927,-0.13653 -0.0028,0.0399 -0.0053,0.078 -0.0081,0.11501 l -0.04833,0.14499",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.552861,256.84798 -0.451202,-20.6629 c 0.750007,-6.49323 2.723092,-11.97399 7.245702,-11.97399 1.09714,0 2.342798,0.32174 3.758848,1.02976 l -0.769056,2.30293 c -7.460544,3.17395 -9.382829,24.4849 -9.713029,29.09041 l -0.07126,0.21379",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.613541,256.78553 c 0.0032,-0.0483 0.0071,-0.0988 0.01058,-0.15134 l 9.713029,-29.09041 c 0.02752,-0.0116 0.05468,-0.0229 0.0822,-0.0342 l -9.67599,28.97892 c -0.04903,0.11113 -0.09208,0.21026 -0.12982,0.29704",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.605426,256.90054 c 0.0028,-0.037 0.0053,-0.0751 0.0081,-0.11501 0.03775,-0.0868 0.08078,-0.18591 0.12982,-0.29704 l -0.137935,0.41205",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.624124,256.63419 c 0.3302,-4.60551 2.252485,-25.91646 9.713029,-29.09041 l -9.713029,29.09041",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.503826,257.19617 c -2.65e-4,-0.002 -7.94e-4,-0.005 -0.0011,-0.008 l 0.0074,-0.002 -0.0032,0.009 c -0.0011,2.7e-4 -0.0021,2.7e-4 -0.0032,8e-4 m -0.0053,-0.0409 c 0,-0.002 -2.64e-4,-0.004 -7.93e-4,-0.006 l 0.02822,-0.0243 c 0,0.004 -2.65e-4,0.006 -7.94e-4,0.01 -0.0095,0.007 -0.01834,0.0141 -0.02681,0.0205",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.525345,257.13478 c 2.64e-4,-0.003 7.93e-4,-0.006 7.93e-4,-0.01 l 0.0063,-0.005 -0.0046,0.013 c -7.94e-4,2.7e-4 -0.0013,10e-4 -0.0024,0.002",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.491126,257.06987 -0.0011,-0.0342 0.05256,-0.15663 c -0.0021,0.0289 -0.0039,0.0568 -0.006,0.084 -0.01728,0.0409 -0.03246,0.0762 -0.04551,0.10689",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.536634,256.96298 c 0.0021,-0.0272 0.0039,-0.055 0.006,-0.084 l 0.01024,-0.031 0.0013,0.0741 c -0.006,0.0141 -0.01199,0.0279 -0.01765,0.0409",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.488657,257.07516 c -0.0011,-0.008 -0.0021,-0.0166 -0.0032,-0.0257 l 0.0046,-0.0138 0.0011,0.0342 c -0.0011,0.002 -0.0019,0.004 -0.0024,0.005",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.497828,257.1496 c -0.0024,-0.0194 -0.0053,-0.0445 -0.0092,-0.0744 7.94e-4,-0.002 0.0013,-0.004 0.0024,-0.005 0.01304,-0.0307 0.02822,-0.066 0.04551,-0.10689 0.0056,-0.013 0.01164,-0.0268 0.01765,-0.0409 l 0.0028,0.12347 -0.02468,0.0744 -0.0063,0.005 -0.02822,0.0243",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.485482,257.04941 c -0.170391,-1.39629 -1.400529,-12.06147 -0.383823,-20.86433 l 0.451202,20.6629 -0.01024,0.031 -0.05257,0.15663 -0.0046,0.0138",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.504532,257.20287 c 0,0 -2.64e-4,-0.002 -7.93e-4,-0.007 0.0011,-2.7e-4 0.0021,-2.7e-4 0.0032,-8e-4 l -0.0024,0.007 v 0",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.502768,257.1884 c -0.0011,-0.008 -0.0024,-0.019 -0.0042,-0.0332 0.0085,-0.006 0.01728,-0.013 0.02681,-0.0205 0.0011,-7.9e-4 0.0019,-0.001 0.0024,-0.002 l -0.01765,0.0536 -0.0074,0.002",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.228659,256.83069 c -0.04868,-0.0667 -0.103716,-0.14182 -0.164393,-0.22507 L 28.06552,238.60513 c -1.850143,-5.47723 -1.858292,-10.43481 3.049729,-12.01914 -3.769184,7.28663 5.227108,26.39836 7.11341,30.2447",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.499945,257.19652 c -0.0013,-0.002 -0.0032,-0.004 -0.0049,-0.006 l 0.0074,-0.002 0.0011,0.008 c -0.0011,0 -0.0024,2.6e-4 -0.0035,2.6e-4 m -0.0071,-0.037 v -0.005 l 0.0032,-0.003 0.0011,0.006 c -0.0013,8e-4 -0.0028,0.002 -0.0042,0.003",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.479836,257.16971 c -7.93e-4,-7.9e-4 -0.0013,-0.002 -0.0021,-0.003 l 0.01516,-0.0127 v 0.005 c -0.0046,0.004 -0.0092,0.007 -0.01304,0.0102 m -0.02011,-0.0265 c -0.0011,-0.002 -0.0024,-0.004 -0.0039,-0.005 l 0.02574,-0.0762 0.0035,0.0219 c -0.0099,0.0229 -0.01834,0.043 -0.0254,0.0596 m -0.04092,-0.055 c -0.0019,-0.002 -0.0039,-0.005 -0.0056,-0.008 l -5.087059,-30.93887 c 0.024,-0.002 0.04657,-0.005 0.07055,-0.007 l 4.874332,29.64674 c 0.06914,0.65582 0.123473,1.10737 0.147814,1.3074",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.47772,257.16689 c -0.0053,-0.007 -0.0113,-0.0148 -0.01799,-0.0236 0.0071,-0.0166 0.01553,-0.0367 0.0254,-0.0596 l 0.01093,0.0674 -0.0032,0.003 -0.01516,0.0127",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.455849,257.13796 c -0.01058,-0.0141 -0.02294,-0.0311 -0.03704,-0.0497 -0.02434,-0.20003 -0.07867,-0.65158 -0.147814,-1.3074 l 0.210608,1.28094 -0.02574,0.0762",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.413161,257.08045 c -0.04551,-0.0614 -0.107595,-0.14499 -0.184502,-0.24976 -1.886302,-3.84634 -10.882594,-22.95807 -7.11341,-30.2447 0.648404,-0.20919 1.383946,-0.35983 2.210858,-0.44485 l 5.087054,30.93931",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.504532,257.20287 c 0,0 -0.0013,-0.002 -0.0046,-0.006 0.0011,0 0.0024,-2.6e-4 0.0035,-2.6e-4 l 0.0011,0.007",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.495007,257.19017 c -0.0039,-0.005 -0.0088,-0.012 -0.01516,-0.0204 0.0039,-0.003 0.0085,-0.006 0.01304,-0.0102 0.0013,-8e-4 0.0028,-0.002 0.0042,-0.003 l 0.0053,0.0317 -0.0074,0.002",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.064266,256.60562 C 36.41397,254.33514 30.562445,245.99688 28.06552,238.60513 l 9.998746,18.00049",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.388116,257.15348 h -2.65e-4 l -0.05115,-0.0579 -0.04445,-0.0801 c 0.03316,0.0448 0.06068,0.0819 0.08255,0.11078 0.0046,0.01 0.0088,0.0183 0.01341,0.0272",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.374709,257.12632 c -0.02188,-0.0289 -0.04939,-0.066 -0.08255,-0.11078 l -0.07832,-0.14111 0.08184,0.0928 c 0.02822,0.0572 0.05468,0.11078 0.07902,0.15911",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.387761,257.15348 c -0.0078,-0.003 -0.01622,-0.007 -0.02506,-0.0106 l -0.02611,-0.0473 0.05115,0.0579",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.343298,233.39672 -1.207029,-1.36278 c 0.01531,-0.01 0.03073,-0.0201 0.04618,-0.0303 l 1.169106,1.3201 c -0.0029,0.0243 -0.0056,0.0487 -0.0083,0.073",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18.923495,235.18036 -1.580197,-1.78364 c 0.0026,-0.0243 0.0054,-0.0487 0.0083,-0.073 l 1.579245,1.78258 c -0.0026,0.0247 -0.0051,0.0494 -0.0073,0.0741",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.425032,256.73509 c -0.414162,-0.1831 -0.935921,-0.41734 -1.543404,-0.6978 L 22.2655,248.56758 C 14.607048,243.43431 8.6255598,236.98165 16.136269,232.03394 l 1.207029,1.36278 1.580197,1.78364 c -0.702662,7.65175 14.205056,18.57517 18.501537,21.55473",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.493595,257.19723 v -0.007 l 0.0056,0.006 c -0.0019,2.6e-4 -0.0039,7.9e-4 -0.0056,7.9e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.492184,257.19758 c -0.0032,-0.001 -0.0063,-0.002 -0.01024,-0.004 l 0.01164,-0.003 v 0.007 c -7.94e-4,2.6e-4 -0.0011,2.6e-4 -0.0013,2.6e-4 m -0.0314,-0.013 c -7.94e-4,-2.7e-4 -0.0013,-8e-4 -0.0021,-0.001 l 0.01622,-0.0141 0.0021,0.002 c -0.006,0.005 -0.01164,0.009 -0.01622,0.0127 m -0.01553,-0.007 c -0.0011,-2.6e-4 -0.0013,-7.9e-4 -0.0021,-10e-4 l 0.01058,-0.0314 0.0035,0.004 c -0.0049,0.0113 -0.0088,0.0208 -0.01199,0.0286 m -0.01588,-0.007 c -2.65e-4,0 -0.0011,-2.6e-4 -0.0013,-7.9e-4 l -0.01093,-0.0667 0.0046,0.005 c 0.0032,0.0258 0.0056,0.0466 0.0078,0.0621 m -0.0314,-0.0134 c -0.0032,-0.001 -0.0064,-0.002 -0.0099,-0.004 -0.0046,-0.009 -0.0088,-0.0177 -0.01341,-0.0272 0.0088,0.012 0.01659,0.0222 0.02328,0.0314",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.45867,257.18347 c -0.0042,-0.002 -0.0088,-0.004 -0.01341,-0.006 0.0032,-0.008 0.0071,-0.0173 0.01199,-0.0286 l 0.01765,0.0201 -0.01622,0.0141",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.443149,257.17676 c -0.0046,-0.002 -0.0092,-0.004 -0.01376,-0.006 -0.0021,-0.0155 -0.0046,-0.0363 -0.0078,-0.0621 l 0.0321,0.0363 -0.01058,0.0314",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.427978,257.17041 c -0.0092,-0.004 -0.01905,-0.008 -0.02999,-0.0127 -0.0067,-0.009 -0.01447,-0.0194 -0.02328,-0.0314 -0.02434,-0.0483 -0.0508,-0.10196 -0.07902,-0.15911 l 0.121357,0.13653 0.01093,0.0667",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.504532,257.20287 c 0,0 -0.0042,-0.002 -0.01236,-0.005 2.65e-4,0 7.94e-4,0 0.0013,-2.7e-4 0.0019,0 0.0039,-2.6e-4 0.0056,-7.9e-4 l 0.0053,0.006",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.481953,257.19334 c -0.006,-0.002 -0.01304,-0.006 -0.02117,-0.009 0.0046,-0.004 0.01024,-0.008 0.01622,-0.0127 l 0.01659,0.0187 v 0 l -0.01164,0.003",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.208903,256.95169 -0.08819,-0.0998 -0.122766,-0.22119 0.06632,0.0751 c 0.0254,0.0346 0.04974,0.0677 0.07267,0.0991 0.02506,0.0511 0.04939,0.10054 0.07197,0.14675",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.336609,257.09563 -0.127706,-0.14394 c -0.02257,-0.0462 -0.04692,-0.0956 -0.07197,-0.14675 0.06033,0.0825 0.112538,0.15275 0.155223,0.2106 l 0.04445,0.0801",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.120709,256.85185 18.923495,235.18036 c 0.0022,-0.0247 0.0047,-0.0494 0.0073,-0.0741 l 19.067145,21.52438 0.122766,0.22119",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.292159,257.01554 c -0.04268,-0.0579 -0.0949,-0.12805 -0.155223,-0.2106 -0.02294,-0.0314 -0.04727,-0.0646 -0.07267,-0.0991 l 0.149577,0.16863 0.07832,0.14111",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.362716,257.1429 c -0.171098,-0.0727 -0.49248,-0.21096 -0.937684,-0.40781 -4.296481,-2.97956 -19.204199,-13.90298 -18.501537,-21.55473 l 19.197214,21.67149 0.08819,0.0998 0.127706,0.14394 0.02611,0.0473",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35.881628,256.03729 C 32.694986,254.56797 27.140466,251.835 22.2655,248.56758 l 13.616128,7.46971",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.069886,257.55706 c 0.58279,-0.0522 1.103138,-0.10301 1.550107,-0.14852 0.0063,2.6e-4 0.01341,10e-4 0.01976,10e-4 -0.454379,0.0459 -0.981075,0.0956 -1.569863,0.14711",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.639749,257.40995 c -0.0063,-2.6e-4 -0.01341,-10e-4 -0.01976,-10e-4 0.06138,-0.006 0.121002,-0.0127 0.179565,-0.0187 0.0071,8e-4 0.0141,0.001 0.02117,0.002 -0.05927,0.006 -0.11924,0.012 -0.180975,0.0183 M 7.3512558,246.82662 6.5626208,246.56345 c 0.0038,-0.008 0.0072,-0.0145 0.01115,-0.0222 l 0.771455,0.25788 c 0.0019,0.009 0.004,0.0183 0.006,0.0275",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20.972076,257.89502 c -9.529691,-0.514 -18.5955162,-3.02507 -14.4094552,-11.33157 l 0.788635,0.26317 c 1.712101,7.81473 23.0965022,10.0651 29.4483012,10.56322 -0.05856,0.006 -0.118181,0.0124 -0.179564,0.0187 -0.446969,0.0455 -0.967317,0.0963 -1.550107,0.14852 -0.155927,0.0134 -0.316087,0.0272 -0.480483,0.0406 l -13.617327,0.29739",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.096016,257.25226 -0.0088,-0.005 c 0.02574,-0.003 0.04974,-0.006 0.07302,-0.008 0.0024,0.002 0.0049,0.003 0.0074,0.005 -0.02257,0.003 -0.04657,0.006 -0.07161,0.008",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2799"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.59507,256.92523 -0.243769,-0.0815 -0.121002,-0.0663 0.291394,0.097 c 0.02506,0.0177 0.04904,0.0339 0.07338,0.0508",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.799682,256.99367 -0.204612,-0.0684 c -0.02434,-0.0169 -0.04833,-0.0332 -0.07338,-0.0508 l 0.204258,0.0684 c 0.0254,0.0173 0.04974,0.0339 0.07373,0.0508",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.087195,257.24732 -0.735894,-0.40358 0.243769,0.0815 0.204612,0.0684 c 0.137229,0.0938 0.257879,0.17568 0.360538,0.24518 -0.02328,0.003 -0.04727,0.006 -0.07303,0.008",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2805"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.400461,257.21028 -7.93e-4,-8e-4 c 0.006,-10e-4 0.01093,-10e-4 0.01516,-0.002 0,2.6e-4 0,2.6e-4 2.65e-4,7.9e-4 l -0.01482,0.002 m 0.0092,-0.013 -0.02045,-0.007 -0.0028,-0.005 c 0.0085,0.004 0.01587,0.007 0.02222,0.01 2.64e-4,7.9e-4 7.94e-4,0.001 0.0011,0.002",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.408576,257.19475 c -0.0064,-0.003 -0.01376,-0.006 -0.02223,-0.01 l -0.01482,-0.0268 0.02257,0.007 c 0.0049,0.01 0.0095,0.0194 0.01447,0.0289",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.399757,257.20957 -0.01058,-0.0194 0.02045,0.007 c 0.0019,0.003 0.0035,0.007 0.0053,0.0102 -0.0042,8e-4 -0.0092,10e-4 -0.01516,0.002",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.403284,257.21557 -0.0028,-0.005 0.01482,-0.002 c 7.94e-4,0.002 0.0019,0.004 0.0028,0.006 -0.0049,2.6e-4 -0.0099,0.001 -0.01482,0.002",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.423041,257.2131 c 0.0071,-0.005 0.01058,-0.008 0.01058,-0.008 l -0.01834,0.003 c -2.65e-4,-2.6e-4 -2.65e-4,-2.6e-4 -2.65e-4,-7.9e-4 0.01236,-0.001 0.01871,-0.002 0.01871,-0.002 l -0.024,-0.008 c -2.64e-4,-0.001 -7.93e-4,-0.002 -0.0011,-0.002 0.01659,0.007 0.02506,0.0102 0.02506,0.0102 v 0 0 l -0.03281,-0.0367 0.0067,0.002 c 0.01728,0.0229 0.02611,0.0346 0.02611,0.0346 v 0 0 l -0.0046,-0.0275 0.0011,2.6e-4 c 0.0024,0.018 0.0035,0.0272 0.0035,0.0272 v 0 l 0.02188,-0.0187 0.0019,7.9e-4 c -0.01588,0.012 -0.02363,0.018 -0.02363,0.018 v 0 0 0 0 0 0 l -0.0024,0.007 c -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 0.0019,-0.005 0.0028,-0.007 0.0028,-0.007 l -0.0088,0.008 c -7.93e-4,0 -0.0011,2.6e-4 -0.0019,2.6e-4 m 0.0113,-0.001 c -2.65e-4,-0.004 -7.94e-4,-0.007 -7.94e-4,-0.007 v 0 l 0.0013,0.007 c -2.64e-4,0 -2.64e-4,0 -7.94e-4,0 m 0.0039,-2.6e-4 c -0.0032,-0.004 -0.0046,-0.006 -0.0046,-0.006 v 0 l 0.0049,0.006 c 0,2.7e-4 -2.64e-4,2.7e-4 -2.64e-4,2.7e-4 m 0.0074,-0.001 c -0.0081,-0.004 -0.01199,-0.005 -0.01199,-0.005 v 0 l 0.01553,0.005 c -0.0011,0 -0.0024,2.7e-4 -0.0035,2.7e-4 m -0.01199,-0.005 0.0078,-0.0233 0.0019,8e-4 c -0.0064,0.0152 -0.0095,0.0226 -0.0095,0.0226 m 0,0 0.04515,-0.0109 0.01093,0.004 c -0.0374,0.005 -0.05609,0.007 -0.05609,0.007",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 v 0 c 0,0 0.0032,-0.007 0.0095,-0.0226 l 0.01236,0.004 -0.02188,0.0187",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 c 0,0 -0.0011,-0.009 -0.0035,-0.0272 l 0.0113,0.004 -0.0078,0.0233",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2819"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 c 0,0 -0.0088,-0.0117 -0.02611,-0.0346 l 0.02151,0.007 0.0046,0.0275",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 c 0,0 -0.0085,-0.004 -0.02506,-0.0102 -0.0049,-0.01 -0.0095,-0.019 -0.01447,-0.0289 l 0.0067,0.002 0.03281,0.0367",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.414926,257.20745 c -0.0019,-0.003 -0.0035,-0.007 -0.0053,-0.0102 l 0.024,0.008 c 0,0 -0.0064,0.001 -0.01871,0.002",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.418101,257.2138 c -0.0011,-0.002 -0.0021,-0.004 -0.0028,-0.006 l 0.01834,-0.003 c 0,0 -0.0035,0.003 -0.01058,0.008 -0.0019,2.6e-4 -0.0035,2.6e-4 -0.0049,7.9e-4",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.424803,257.21275 0.0088,-0.008 c 0,0 -0.0011,0.002 -0.0028,0.007 -0.0021,2.6e-4 -0.0039,7.9e-4 -0.006,7.9e-4",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.431153,257.21204 0.0024,-0.007 v 0 0 0 0 c 0,0 2.65e-4,0.002 7.94e-4,0.007 -0.0011,0 -0.0021,2.7e-4 -0.0032,2.7e-4",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.435034,257.21169 -0.0013,-0.007 c 0,0 0.0013,0.002 0.0046,0.006 -0.0011,0 -0.0021,0 -0.0032,2.7e-4 m -0.0013,-0.007 v 0 0 0",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.438561,257.21098 -0.0049,-0.006 c 0,0 0.0039,0.002 0.01199,0.005 -0.0021,2.6e-4 -0.0046,7.9e-4 -0.0071,7.9e-4 m -0.0049,-0.006 v 0 0 0",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.449145,257.20993 -0.01553,-0.005 c 0,0 0.01871,-0.002 0.05609,-0.007 l 0.01482,0.005 c 0,0 -0.01871,0.002 -0.05539,0.007",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.433624,257.20499 v 0 0 0 0 0 0 c 0,0 0.0078,-0.006 0.02363,-0.018 l 0.02151,0.007 -0.04515,0.0109",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.326378,257.22227 -0.0019,-0.004 c 0.0053,-7.9e-4 0.01093,-0.001 0.01588,-0.002 2.64e-4,7.9e-4 7.94e-4,0.002 0.0013,0.003 l -0.01553,0.002",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.341901,257.2198 c -7.94e-4,-0.001 -0.0011,-0.002 -0.0013,-0.003 0.02434,-0.003 0.04445,-0.006 0.05927,-0.007 l 7.94e-4,8e-4 -0.05856,0.01",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.167628,257.24379 c -0.0024,-0.002 -0.0049,-0.003 -0.0074,-0.005 0.06667,-0.008 0.121708,-0.0148 0.164396,-0.0201 l 0.0019,0.004 -0.06773,0.0109 c -0.02787,0.003 -0.05821,0.007 -0.09102,0.0106",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.314736,257.16548 -0.02434,-0.008 -0.0092,-0.0166 c 0.0092,0.004 0.01834,0.008 0.02716,0.0113 0.0021,0.005 0.0042,0.009 0.0063,0.0134",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.389174,257.19017 -0.07444,-0.0247 c -0.0021,-0.004 -0.0042,-0.009 -0.0064,-0.0134 0.03211,0.0138 0.05821,0.0247 0.07796,0.0332 l 0.0028,0.005",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.290395,257.15736 -0.490713,-0.16369 c -0.024,-0.0169 -0.04833,-0.0335 -0.07373,-0.0508 l 0.420865,0.14041 c 0.0515,0.0222 0.09631,0.0413 0.134408,0.0575 l 0.0092,0.0166",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.386351,257.18523 c -0.01976,-0.008 -0.04586,-0.0194 -0.07796,-0.0332 -0.0088,-0.004 -0.01799,-0.007 -0.02716,-0.0113 -0.0381,-0.0162 -0.0829,-0.0353 -0.134408,-0.0575 l 0.224718,0.0751 0.01482,0.0268",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.16022,257.23885 c -0.102659,-0.0695 -0.223309,-0.15134 -0.360538,-0.24518 l 0.490713,0.16369 0.02434,0.008 0.07444,0.0247 0.01058,0.0194 c -0.01482,0.002 -0.03493,0.004 -0.05927,0.007 -0.0049,2.7e-4 -0.01058,0.001 -0.01588,0.002 -0.04269,0.005 -0.09772,0.012 -0.164396,0.0201",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.258645,257.23321 0.06773,-0.0109 0.01553,-0.002 0.05856,-0.01 0.0028,0.005 c -0.0381,0.005 -0.08643,0.0106 -0.14464,0.0177",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.002528,257.26319 -0.0088,-0.005 c 0.02681,-0.003 0.05256,-0.006 0.07726,-0.009 0.0024,0.002 0.0049,0.003 0.0074,0.005 -0.024,0.003 -0.04974,0.006 -0.07585,0.009",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.078376,257.25438 c -0.0024,-0.002 -0.0049,-0.003 -0.0074,-0.005 0.0053,-8e-4 0.01093,-10e-4 0.01622,-0.002 l 0.0088,0.005 c -0.006,7.9e-4 -0.01164,10e-4 -0.01765,0.002",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.820724,257.3916 c -0.0071,-7.9e-4 -0.0141,-10e-4 -0.02117,-0.002 0.511175,-0.0529 0.915811,-0.0988 1.194152,-0.13123 l 0.0088,0.005 c -0.285044,0.0332 -0.684742,0.0776 -1.181804,0.12841",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.351301,256.84374 -0.289983,-0.097 -0.121357,-0.0663 0.290338,0.097 0.121002,0.0663",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37.061318,256.74673 7.3512558,246.82662 c -0.002,-0.009 -0.0041,-0.0183 -0.006,-0.0275 l 29.5947382,9.8813 0.121357,0.0663",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.799557,257.38984 C 30.447758,256.89172 9.0633568,254.64135 7.3512558,246.82662 l 29.7100622,9.92011 0.289983,0.097 0.735894,0.40358 c -0.0053,7.9e-4 -0.01093,10e-4 -0.01622,0.002 -0.02469,0.003 -0.05045,0.006 -0.07726,0.009 -0.278341,0.0325 -0.682977,0.0783 -1.194152,0.13123",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2869"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.254622,258.00438 c -1.409594,0 -2.85048,-0.0321 -4.282546,-0.10936 l 13.617327,-0.29739 c -2.439458,0.20249 -5.783331,0.40675 -9.334781,0.40675",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.225234,258.7879 c 0.224719,-0.15593 0.434975,-0.30304 0.62865,-0.43991 0.06879,-0.0325 0.135467,-0.0646 0.200377,-0.0956 -0.164041,0.11607 -0.340429,0.23954 -0.528812,0.37042 l -0.300215,0.1651",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.15362,258.83764 c 0.024,-0.0162 0.04833,-0.0332 0.07161,-0.0497 l 0.300215,-0.1651 c -0.02328,0.0166 -0.04727,0.0332 -0.07091,0.0494 l -0.300921,0.16545",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.280199,268.61699 c -2.591399,0 -4.6943082,-0.92498 -5.8222092,-3.30129 1.090825,0.38982 2.3784632,0.56021 3.7981472,0.56021 7.993027,0 20.144987,-5.40914 24.597747,-7.52792 -0.193675,0.13687 -0.403931,0.28398 -0.62865,0.43991 -0.02328,0.0166 -0.04762,0.0335 -0.07161,0.0497 l -15.212836,8.36366 c -2.36167,0.86289 -4.656807,1.41569 -6.660585,1.41569",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2877"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.003586,257.52319 c 0.0067,-0.005 0.01342,-0.01 0.01976,-0.0145 0.02151,10e-4 0.04233,0.002 0.06244,0.004 -0.0042,0.003 -0.0085,0.006 -0.0127,0.009 l -0.0695,0.001",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.085784,257.51261 c -0.02011,-10e-4 -0.04092,-0.003 -0.06244,-0.004 0.01304,-0.01 0.02574,-0.019 0.03845,-0.0282 0.01905,10e-4 0.03845,0.002 0.0568,0.004 l -0.02752,0.0243 c -0.0019,10e-4 -0.0039,0.002 -0.0053,0.004",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2881"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.264041,257.56129 0.897112,-0.14358 c 0.367948,0.0275 0.670983,0.048 0.900642,0.0628 -0.0127,0.009 -0.0254,0.0187 -0.03845,0.0282 -0.0064,0.005 -0.01304,0.01 -0.01976,0.0145 l -1.739545,0.0381",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.091076,257.50873 0.02752,-0.0243 c 0.0019,0 0.0032,0 0.0053,2.6e-4 -0.01093,0.008 -0.02188,0.0159 -0.03281,0.024",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.271699,257.34857 -0.01765,-0.01 c 0.0092,-0.007 0.01765,-0.013 0.02611,-0.0194 0.0046,0.003 0.0092,0.006 0.01376,0.009 l -0.02223,0.0198",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.254059,257.33904 -0.135818,-0.0744 0.06491,-0.0102 c 0.03457,0.0233 0.06667,0.0452 0.09701,0.0653 -0.0085,0.006 -0.01693,0.0127 -0.02611,0.0194",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.292866,257.36021 -0.02117,-0.0116 0.02223,-0.0198 c 0.0074,0.005 0.01447,0.01 0.02188,0.0148 -0.0074,0.005 -0.01516,0.0109 -0.02294,0.0166",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2891"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.419866,257.2452 -0.0019,-0.003 c 0.0024,-0.006 0.0046,-0.0106 0.0064,-0.0152 2.64e-4,2.6e-4 7.93e-4,0.001 0.0011,0.002 l -0.0056,0.0166 m -0.01058,-0.0187 -0.0011,-0.002 c 0.0035,-0.003 0.0071,-0.006 0.01024,-0.008 h 7.94e-4 c 2.64e-4,0 2.64e-4,2.7e-4 7.94e-4,8e-4 l -0.01058,0.009",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.408224,257.22439 -0.0032,-0.006 0.01342,-0.002 c -0.0032,0.002 -0.0067,0.005 -0.01024,0.008",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.418101,257.24203 -0.0088,-0.0155 0.01058,-0.009 c 0.0013,0.003 0.0032,0.006 0.0046,0.01 -0.0019,0.005 -0.0039,0.01 -0.0063,0.0152",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.427978,257.26002 -0.0081,-0.0148 0.0056,-0.0166 c 0.0042,0.008 0.0081,0.0162 0.01199,0.0243 -0.0032,0.002 -0.0064,0.005 -0.0095,0.007",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.439268,257.25155 c -0.0021,-0.0173 -0.0035,-0.03 -0.0046,-0.0374 l 7.94e-4,-2.7e-4 0.0071,0.0356 c -0.0011,7.9e-4 -0.0019,10e-4 -0.0032,0.002 m 0.01905,-0.0141 c -0.0081,-0.0106 -0.01447,-0.0187 -0.01871,-0.0243 h 2.65e-4 l 0.01939,0.0236 c -2.65e-4,2.6e-4 -7.94e-4,7.9e-4 -0.0011,7.9e-4 m -0.03281,-0.009 c -2.64e-4,-2.7e-4 -7.93e-4,-0.001 -0.0011,-0.002 0.0021,-0.005 0.0039,-0.009 0.0049,-0.012 h 7.93e-4 l -0.0046,0.0138 m 0.05151,-0.005 c -0.01164,-0.005 -0.02082,-0.009 -0.02787,-0.012 l 0.0039,-8e-4 0.02893,0.009 c -0.0019,10e-4 -0.0032,0.002 -0.0049,0.004 m -0.05715,-0.006 c -2.65e-4,-2.6e-4 -2.65e-4,-7.9e-4 -7.94e-4,-7.9e-4 l 0.0019,-2.7e-4 -0.0011,10e-4",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.424451,257.22686 c -0.0013,-0.003 -0.0032,-0.006 -0.0046,-0.01 l 0.0011,-10e-4 0.0085,-0.001 c -0.0011,0.003 -0.0028,0.007 -0.0049,0.012",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2903"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.437503,257.25296 c -0.0039,-0.008 -0.0078,-0.0159 -0.01199,-0.0243 l 0.0046,-0.0138 0.0046,-7.9e-4 c 0.0011,0.007 0.0024,0.0201 0.0046,0.0374 -2.64e-4,8e-4 -0.0011,0.001 -0.0019,0.001",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.442443,257.24944 -0.0071,-0.0356 0.0042,-7.9e-4 c 0.0042,0.006 0.01058,0.0138 0.01871,0.0243 -0.0049,0.004 -0.01024,0.008 -0.01587,0.012",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2907"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.459376,257.23674 -0.01939,-0.0236 0.0092,-0.001 c 0.0071,0.003 0.01622,0.007 0.02787,0.012 -0.0053,0.004 -0.01093,0.008 -0.01765,0.013",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.481953,257.2198 -0.02893,-0.009 0.05151,-0.008 c 0,0 -0.0078,0.006 -0.02257,0.0169",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.355307,257.27448 -0.0042,-0.008 c 0.0035,-0.002 0.0071,-0.005 0.01024,-0.007 0.0013,0.002 0.0024,0.005 0.0035,0.007 l -0.0095,0.008",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.364832,257.26602 c -0.0011,-0.002 -0.0021,-0.005 -0.0035,-0.007 0.01976,-0.0148 0.03528,-0.0264 0.04692,-0.0349 l 0.0011,0.002 -0.04445,0.0395",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2915"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.293924,257.32881 c -0.0046,-0.003 -0.0092,-0.006 -0.01376,-0.009 0.02716,-0.0201 0.0508,-0.0378 0.07091,-0.0529 l 0.0042,0.008 -0.06138,0.0543",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.402226,257.27907 c 0.0064,-0.0141 0.01164,-0.0268 0.01588,-0.037 l 0.0019,0.003 -0.0099,0.0286 c -0.0028,0.002 -0.0049,0.004 -0.0078,0.005",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.280166,257.31964 c -0.03034,-0.0201 -0.06244,-0.042 -0.09701,-0.0653 l 0.221898,-0.0356 0.0032,0.006 c -0.01164,0.008 -0.02717,0.0201 -0.04692,0.0349 -0.0032,0.002 -0.0067,0.005 -0.01024,0.007 -0.02011,0.0152 -0.04375,0.0328 -0.07091,0.0529",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2921"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.315795,257.34363 c -0.0074,-0.005 -0.01447,-0.01 -0.02188,-0.0148 l 0.06138,-0.0543 0.0095,-0.008 0.04445,-0.0395 0.0088,0.0155 c -0.0042,0.0102 -0.0095,0.0229 -0.01588,0.037 -0.02434,0.0183 -0.05327,0.0399 -0.08643,0.0646",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.409986,257.27378 0.0099,-0.0286 0.0081,0.0148 c -0.0056,0.004 -0.01199,0.009 -0.01799,0.0138",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.228307,257.38702 -0.02257,-0.0124 c 0.0081,-0.006 0.01659,-0.0123 0.02434,-0.018 0.0063,0.004 0.01236,0.008 0.01871,0.0124 l -0.02045,0.018",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.248768,257.36903 c -0.0063,-0.004 -0.01236,-0.008 -0.01871,-0.0124 0.0085,-0.006 0.01622,-0.012 0.024,-0.0177 l 0.01765,0.01 -0.02294,0.0204",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.118593,257.48439 c -0.01834,-0.001 -0.03775,-0.002 -0.0568,-0.004 0.05327,-0.0392 0.1016,-0.0744 0.143933,-0.10584 l 0.02257,0.0124 -0.109715,0.0974",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.061795,257.4805 c -0.229659,-0.0148 -0.532694,-0.0353 -0.900642,-0.0628 l 0.957088,-0.15311 0.135818,0.0744 c -0.0078,0.006 -0.01553,0.0113 -0.024,0.0177 -0.0078,0.006 -0.01622,0.012 -0.02434,0.018 -0.04233,0.0314 -0.09066,0.0667 -0.143933,0.10584",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.123884,257.48474 c -0.0021,-2.7e-4 -0.0035,-2.7e-4 -0.0053,-2.7e-4 l 0.109714,-0.0974 0.02045,-0.018 0.02294,-0.0205 0.02117,0.0116 c -0.04833,0.036 -0.104775,0.0773 -0.168982,0.12453",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.853884,258.34799 c 0.006,-0.004 0.01164,-0.008 0.01728,-0.012 0.0695,-0.0332 0.137231,-0.066 0.202496,-0.0974 -0.006,0.005 -0.01304,0.01 -0.01939,0.0138 -0.06491,0.031 -0.131585,0.0631 -0.200377,0.0956 m 1.115131,-0.79939 c 0.01164,-0.009 0.02328,-0.0173 0.03457,-0.0254 l 0.0695,-10e-4 c -0.0113,0.008 -0.02294,0.0166 -0.03457,0.025 l -0.0695,0.002",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.87117,258.33599 c 0.462491,-0.32667 0.833614,-0.59478 1.097846,-0.7874 l 0.06949,-0.002 c -0.238829,0.17427 -0.564091,0.40887 -0.964845,0.6918 -0.06527,0.0314 -0.132998,0.0642 -0.202496,0.0974",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.256137,265.87591 c -1.419684,0 -2.7073222,-0.17039 -3.7981472,-0.56021 -0.40834,-0.86042 -0.688622,-1.91065 -0.818021,-3.17676 l 28.6240722,-4.57765 1.739545,-0.0381 c -0.0113,0.008 -0.02294,0.0166 -0.03457,0.0254 -0.264232,0.19262 -0.635355,0.46073 -1.097846,0.7874 -0.0056,0.004 -0.0113,0.008 -0.01728,0.012 -4.45276,2.11878 -16.604721,7.52792 -24.597747,7.52792",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 30.445253,262.5351 c 2.2963,-1.38465 4.288438,-2.71321 5.708367,-3.69746 l 0.300921,-0.16545 c -1.45133,1.00789 -3.569759,2.41935 -6.009288,3.86291",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20.940784,267.2013 15.212836,-8.36366 c -1.419929,0.98425 -3.412067,2.31281 -5.708367,3.69746 -2.905161,1.71909 -6.266745,3.48333 -9.504469,4.6662",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.407745,259.52979 c 0.156633,-0.34325 0.296333,-0.65405 0.418748,-0.92921 0.06914,-0.0995 0.133702,-0.19298 0.193675,-0.28011 -0.06773,0.15275 -0.142523,0.31997 -0.223309,0.49988 l -0.389114,0.70944",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.142809,260.10694 c 0.09313,-0.20074 0.181327,-0.3937 0.264936,-0.57715 l 0.389114,-0.70944 c -0.07549,0.16863 -0.157339,0.3489 -0.244123,0.53975 l -0.409927,0.74684",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18.529901,283.02409 c -1.837055,0 -3.610575,-1.02906 -5.223721,-3.49885 l 2.961146,-2.62326 c 0.219498,0.0254 0.441501,0.0378 0.66615,0.0378 7.620811,0 18.05104,-14.24305 20.893017,-18.33915 -0.122415,0.27516 -0.262115,0.58596 -0.418748,0.92921 -0.08361,0.18345 -0.171802,0.37641 -0.264936,0.57715 l -7.496669,13.66555 c -3.418346,5.0292 -7.396479,9.2516 -11.116239,9.2516",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.227601,257.68723 c 0.0013,-0.003 0.0021,-0.005 0.0035,-0.008 0.01587,-0.008 0.0314,-0.0155 0.04621,-0.0229 l -0.0013,0.004 -0.04833,0.0264",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.221957,257.70064 c 0.0019,-0.004 0.0039,-0.009 0.0056,-0.0134 l 0.04833,-0.0264 -0.0046,0.0127 -0.04939,0.0272",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.485709,258.10528 0.15099,-0.13371 c 0.244121,-0.11888 0.443442,-0.21696 0.594429,-0.2921 -0.0013,0.003 -0.0021,0.005 -0.0035,0.008 -0.0019,0.004 -0.0039,0.009 -0.0056,0.0134 l -0.736248,0.40464",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.271345,257.67348 0.0046,-0.0127 0.0013,-0.004 c 0.01482,-0.007 0.02893,-0.0145 0.04268,-0.0212 -0.0021,0.005 -0.0042,0.01 -0.0063,0.0148 l -0.04233,0.0233",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.301332,257.51649 c 0.0028,-0.007 0.0056,-0.0138 0.0088,-0.0205 0.0074,7.9e-4 0.01482,10e-4 0.02222,10e-4 l -0.0064,0.0187 -0.02469,2.7e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.146461,257.52002 0.03598,-0.0318 c 0.04657,0.003 0.08925,0.006 0.127706,0.008 -0.0032,0.007 -0.006,0.0138 -0.0088,0.0204 l -0.154871,0.004",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.326026,257.51614 0.0064,-0.0187 c 0.01587,0.001 0.0314,0.002 0.04586,0.003 -0.0021,0.005 -0.0042,0.01 -0.0063,0.0148 l -0.04586,10e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.365891,257.40043 -0.01199,-0.007 c 0.0028,-0.007 0.0053,-0.013 0.0081,-0.019 0.0035,0.002 0.0071,0.005 0.01058,0.007 l -0.0067,0.0187",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2967"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.353895,257.39372 -0.03986,-0.0219 0.01871,-0.0169 c 0.01024,0.007 0.01976,0.0134 0.02928,0.0198 -0.0028,0.006 -0.0053,0.0124 -0.0081,0.019",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.410341,257.42477 -0.04445,-0.0243 0.0067,-0.0187 c 0.01553,0.0102 0.02999,0.0201 0.04374,0.0293 -0.0019,0.005 -0.0039,0.009 -0.006,0.0138",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2971"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.454436,257.308 -0.01058,-0.0191 c -0.0011,-0.0109 -0.0024,-0.0205 -0.0035,-0.0293 l 2.65e-4,-2.7e-4 c 0.0024,0.005 0.0046,0.009 0.0067,0.0134 l 0.0071,0.0353",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.443853,257.28895 -0.01199,-0.0219 0.0085,-0.007 c 0.0011,0.009 0.0024,0.0183 0.0035,0.0293",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.457966,257.31364 -0.0035,-0.006 -0.0071,-0.0353 c 0.0053,0.0102 0.01024,0.0205 0.01516,0.03 -0.0019,0.004 -0.0032,0.007 -0.0046,0.0109",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.447382,257.27272 c -0.0021,-0.005 -0.0042,-0.009 -0.0067,-0.0134 l 0.0035,-0.003 0.0032,0.0162 m 0.0314,-0.008 c -0.0067,-0.009 -0.0127,-0.0166 -0.01765,-0.0233 l 0.0011,-10e-4 0.01765,0.0215 c -2.64e-4,10e-4 -7.93e-4,0.002 -0.0011,0.003",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.494301,257.22721 v -0.004 l 0.0013,2.7e-4 c -2.65e-4,0.001 -7.94e-4,0.002 -0.0013,0.003",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.492891,257.23039 c -0.0046,-0.002 -0.0088,-0.004 -0.01304,-0.006 l 0.0046,-0.004 0.0099,0.003 v 0.004 c -2.64e-4,10e-4 -7.94e-4,0.002 -0.0013,0.003",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.462551,257.3027 c -0.0049,-0.01 -0.0099,-0.0198 -0.01516,-0.03 l -0.0032,-0.0162 0.01693,-0.0152 c 0.0049,0.007 0.01093,0.0145 0.01765,0.0233 -0.0049,0.0113 -0.01024,0.024 -0.01622,0.0381",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.479836,257.26178 -0.01765,-0.0215 0.01765,-0.0155 c 0.0042,0.002 0.0085,0.004 0.01304,0.006 -0.0035,0.008 -0.0078,0.0191 -0.01304,0.0314",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.495711,257.22404 -0.0013,-2.7e-4 -0.0099,-0.003 0.02011,-0.0177 c 0,0 -0.0028,0.007 -0.0088,0.0212",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.38882,257.33445 -0.0056,-0.01 c 0.0019,-0.004 0.0035,-0.008 0.0049,-0.012 0.0019,0.003 0.0032,0.007 0.0049,0.01 l -0.0042,0.012",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2991"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.393053,257.32246 c -0.0019,-0.003 -0.0032,-0.007 -0.0049,-0.01 0.0019,-0.004 0.0032,-0.007 0.0046,-0.0106 l 0.01058,-0.01 -0.01024,0.03",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.372593,257.38173 c -0.0035,-0.002 -0.0071,-0.005 -0.01058,-0.007 0.0078,-0.0183 0.01482,-0.0349 0.02117,-0.0501 l 0.0056,0.01 -0.01622,0.0473",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2995"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.449499,257.3334 c -0.0021,-0.0162 -0.0039,-0.031 -0.0056,-0.0445 l 0.01058,0.0191 0.0021,0.009 c -0.0024,0.005 -0.0046,0.0106 -0.0071,0.0162",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.362009,257.37467 c -0.0095,-0.006 -0.01905,-0.013 -0.02928,-0.0198 l 0.05997,-0.0529 c -0.0013,0.004 -0.0028,0.007 -0.0046,0.0106 -0.0013,0.004 -0.0032,0.008 -0.0049,0.012 -0.0063,0.0152 -0.01341,0.0317 -0.02117,0.0501",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path2999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.416336,257.41101 c -0.01376,-0.009 -0.02822,-0.019 -0.04374,-0.0293 l 0.01622,-0.0473 0.0042,-0.012 0.01024,-0.03 0.02858,-0.0254 0.01199,0.0219 c 0.0019,0.0134 0.0035,0.0282 0.0056,0.0445 -0.0099,0.0229 -0.02082,0.0487 -0.03316,0.0776",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.456553,257.31717 -0.0021,-0.009 0.0035,0.006 c -7.94e-4,0.001 -0.0011,0.002 -0.0013,0.004",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.347899,257.45264 -0.01553,-0.008 c 0.0021,-0.005 0.0042,-0.01 0.0063,-0.0152 0.0046,0.003 0.0095,0.007 0.0141,0.01 l -0.0049,0.0141",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.352836,257.43853 c -0.0046,-0.003 -0.0095,-0.006 -0.0141,-0.01 0.0053,-0.012 0.01024,-0.024 0.01516,-0.0353 l 0.01199,0.007 -0.01304,0.0381",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.332376,257.49744 c -0.0074,-2.7e-4 -0.01482,-8e-4 -0.02222,-10e-4 0.0074,-0.018 0.01516,-0.0356 0.02222,-0.0519 l 0.01553,0.008 -0.01553,0.0448",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3009"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.310151,257.49603 c -0.03845,-0.002 -0.08114,-0.005 -0.127706,-0.008 l 0.131587,-0.11642 0.03986,0.0219 c -0.0049,0.0113 -0.0099,0.0233 -0.01516,0.0353 -0.0021,0.005 -0.0042,0.01 -0.0063,0.0152 -0.0071,0.0162 -0.01482,0.0339 -0.02223,0.0519",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.378236,257.50026 c -0.01447,-0.001 -0.02999,-0.002 -0.04586,-0.003 l 0.01553,-0.0448 0.0049,-0.0141 0.01304,-0.0381 0.04445,0.0243 c -0.0099,0.0233 -0.02045,0.0483 -0.03211,0.0755",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3013"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.231128,257.67947 c 0.0011,-0.003 0.0024,-0.006 0.0035,-0.008 0.01588,-0.008 0.03104,-0.0155 0.04551,-0.0229 l -0.0028,0.008 c -0.01482,0.007 -0.03034,0.0152 -0.04621,0.0229 m 0.05927,-0.13793 c 0.0024,-0.006 0.0046,-0.0109 0.0071,-0.0162 0.0085,7.9e-4 0.01693,10e-4 0.02469,10e-4 l -0.0049,0.0141 -0.02681,8e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.322145,257.52672 c -0.0078,-2.6e-4 -0.01622,-7.9e-4 -0.02469,-0.001 0.0011,-0.003 0.0024,-0.006 0.0039,-0.009 l 0.02469,-2.7e-4 -0.0039,0.0106",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.234657,257.671 c 0.02011,-0.0466 0.0388,-0.0896 0.05574,-0.12946 l 0.02681,-8e-4 -0.03704,0.10725 c -0.01447,0.007 -0.02963,0.0148 -0.04551,0.0229",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.636699,257.97157 0.509762,-0.45155 0.154871,-0.004 c -0.0013,0.003 -0.0028,0.006 -0.0039,0.009 -0.0024,0.005 -0.0046,0.0106 -0.0071,0.0162 -0.01693,0.0399 -0.03563,0.0829 -0.05574,0.12947 -0.0011,0.003 -0.0024,0.006 -0.0035,0.008 -0.150987,0.0752 -0.350309,0.17322 -0.594429,0.2921",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.277343,257.65654 0.0028,-0.008 0.03704,-0.10725 0.0049,-0.0141 0.0039,-0.0106 0.04586,-0.001 c -0.01588,0.037 -0.03316,0.0769 -0.05186,0.12029 -0.01376,0.007 -0.02787,0.0138 -0.04268,0.0212",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.826493,258.60058 c 0.02928,-0.0656 0.0575,-0.12948 0.08502,-0.19121 0.07126,-0.10372 0.136525,-0.19897 0.19544,-0.2854 -0.02752,0.0624 -0.05644,0.12806 -0.08678,0.1965 -0.05997,0.0871 -0.124532,0.18062 -0.193675,0.28011",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.911511,258.40937 c 0.125238,-0.28293 0.228955,-0.5207 0.310446,-0.70873 l 0.04939,-0.0272 -0.123471,0.35665 c -0.01304,0.0303 -0.02681,0.0617 -0.04092,0.0938 -0.05891,0.0864 -0.124177,0.18168 -0.19544,0.2854",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.933476,276.93973 c -0.224649,0 -0.446652,-0.0124 -0.66615,-0.0378 l 21.218383,-18.7967 0.736248,-0.40464 c -0.08149,0.18803 -0.185208,0.4258 -0.310446,0.70873 -0.02752,0.0617 -0.05574,0.12559 -0.08502,0.19121 -2.841977,4.0961 -13.272206,18.33915 -20.893017,18.33915",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.147874,258.03013 0.123471,-0.35665 0.04233,-0.0233 c -0.04727,0.10866 -0.102304,0.23566 -0.165804,0.37994",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.391951,269.39205 c 2.02706,-3.56765 3.687585,-6.98289 4.750858,-9.28511 l 0.409927,-0.74684 c -1.04422,2.2913 -2.880077,6.11717 -5.160785,10.03195",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 29.64614,273.77249 7.496669,-13.66555 c -1.063273,2.30222 -2.723798,5.71746 -4.750858,9.28511 -0.85866,1.47355 -1.77941,2.95874 -2.745811,4.38044",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.577909,258.47816 c -0.01587,-0.14887 -0.03069,-0.2861 -0.0441,-0.41063 0.0071,-0.11078 0.01304,-0.20532 0.01765,-0.28399 l 0.01976,0.0963 0.0067,0.59831",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.494132,289.41219 c -0.968729,0 -2.052214,-0.24413 -3.264747,-0.77541 8.140489,-2.44158 10.044431,-26.57934 10.304426,-30.56925 0.01342,0.12453 0.02822,0.26176 0.0441,0.41063 l 0.211315,19.41618 c -0.796573,6.26393 -2.803879,11.51785 -7.295092,11.51785",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.571207,257.87985 -0.01976,-0.0963 c 0.0032,-0.0476 0.0056,-0.0889 0.0074,-0.12418 0.0035,0.0303 0.0074,0.0624 0.01093,0.096 l 0.0013,0.12453",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.495359,257.64173 c 7.94e-4,-0.009 0.0011,-0.0169 0.0013,-0.0243 0.0019,-0.003 0.0035,-0.005 0.0053,-0.008 v 0.0198 l -0.0067,0.0123",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.487599,257.65619 c -0.0011,-0.007 -0.0019,-0.0141 -0.0024,-0.0212 0.0039,-0.006 0.0078,-0.012 0.01164,-0.0177 -2.65e-4,0.007 -7.94e-4,0.0155 -0.0013,0.0244 l -0.0078,0.0145",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.502061,257.62938 v -0.0198 c 0.0035,-0.006 0.0074,-0.0113 0.01058,-0.0166 l 0.0028,0.0124 -0.01342,0.024",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.108716,258.34658 0.10936,-0.31539 c 0.118181,-0.17392 0.20814,-0.30797 0.267052,-0.39617 7.94e-4,0.007 0.0013,0.0138 0.0024,0.0212 l -0.378883,0.69039",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.515468,257.60539 -0.0028,-0.0124 c 0.01341,-0.0201 0.02434,-0.0367 0.03281,-0.0494 2.65e-4,0.002 7.94e-4,0.004 7.94e-4,0.005 l -0.03069,0.0564",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.49042,257.55283 c 0.0013,-0.002 0.0024,-0.003 0.0035,-0.005 2.64e-4,0 0.0011,-2.7e-4 0.0013,-8e-4 l -0.0021,0.005 -0.0028,10e-4 m 0.01024,-0.005 c 0,-10e-4 0,-0.002 0,-0.003 2.65e-4,0 2.65e-4,0 7.94e-4,0 v 0.003 l -7.94e-4,2.7e-4",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.476309,257.56059 c 0,-10e-4 0,-0.002 -2.64e-4,-0.004 0.0064,-0.003 0.01236,-0.006 0.01799,-0.009 -0.0011,0.002 -0.0021,0.003 -0.0035,0.005 l -0.0141,0.008",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.493243,257.55177 0.0021,-0.005 c 0.0019,-10e-4 0.0035,-0.002 0.0053,-0.003 0,0.001 0,0.002 0,0.003 l -0.0074,0.004",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501357,257.54718 v -0.003 c 2.65e-4,-2.7e-4 7.94e-4,-7.9e-4 0.0013,-7.9e-4 l 2.65e-4,0.002 -0.0019,10e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.358128,257.62585 0.0042,-0.0116 c 0.04516,-0.0226 0.08326,-0.042 0.113596,-0.0572 2.65e-4,10e-4 2.65e-4,0.002 2.65e-4,0.004 l -0.118181,0.0653",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.50312,257.54612 -2.65e-4,-0.002 c 0.01659,-0.008 0.03034,-0.0155 0.04057,-0.0205 0,2.6e-4 0,2.6e-4 0,7.9e-4 l -0.04022,0.0222",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.487599,257.51261 -0.0035,-0.006 c 7.94e-4,0 0.0011,0 0.0019,0 0.0011,0.002 0.0021,0.004 0.0028,0.006 h -0.0011",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.488657,257.51261 c -7.93e-4,-0.002 -0.0019,-0.004 -0.0028,-0.006 0.0032,2.6e-4 0.0063,2.6e-4 0.0092,7.9e-4 l 0.0013,0.005 -0.0078,2.7e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.470666,257.51296 c 0,-0.003 -2.65e-4,-0.005 -7.94e-4,-0.007 0.0049,2.7e-4 0.0095,2.7e-4 0.0141,8e-4 l 0.0035,0.006 -0.01693,2.6e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3069"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.396582,257.51473 0.0046,-0.0131 c 0.02611,0.001 0.04868,0.003 0.06879,0.004 2.65e-4,0.002 7.94e-4,0.005 7.94e-4,0.007 l -0.07408,0.002",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.496418,257.51225 -0.0013,-0.005 c 0.01939,10e-4 0.03493,0.002 0.04657,0.002 0,8e-4 2.65e-4,10e-4 2.65e-4,0.002 l -0.04551,7.9e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.486893,257.46675 -0.02294,-0.0127 c -7.93e-4,-0.004 -0.0011,-0.008 -0.0013,-0.0127 0.0078,0.005 0.01516,0.0102 0.02222,0.0152 l 0.0021,0.0102",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3075"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.463961,257.45405 -0.0388,-0.0212 0.0046,-0.0134 c 0.01164,0.008 0.02257,0.0152 0.03281,0.0219 2.65e-4,0.004 7.94e-4,0.008 0.0013,0.0127",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.540161,257.49603 -0.05327,-0.0293 -0.0021,-0.0102 c 0.02294,0.0152 0.04127,0.0272 0.05503,0.0363 0,10e-4 0,0.002 2.65e-4,0.003 m -0.0053,-0.0434 -0.07197,-0.12947 0.0039,-0.0113 c 0.02822,0.0564 0.0508,0.10089 0.06738,0.1337 2.65e-4,0.002 2.65e-4,0.005 7.94e-4,0.007",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.514409,257.31188 c -0.0067,-0.009 -0.01304,-0.0169 -0.01871,-0.0247 v -0.006 l 0.01905,0.0233 c 0,0.002 -2.64e-4,0.005 -2.64e-4,0.007",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.518643,257.31788 c -0.0013,-0.002 -0.0028,-0.004 -0.0042,-0.006 0,-0.002 2.65e-4,-0.005 2.65e-4,-0.007 l 0.0028,0.004 c 2.65e-4,0.003 7.94e-4,0.006 0.0011,0.01",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.495711,257.28718 c -0.0049,-0.007 -0.0095,-0.0127 -0.01376,-0.0183 l 0.0011,-0.003 0.0127,0.0155 v 0.006",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.509118,257.23744 c -0.0053,-0.002 -0.0099,-0.004 -0.01447,-0.006 l 0.0024,-0.007 0.01058,0.004 c 2.64e-4,0.003 7.93e-4,0.006 0.0013,0.01",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.534166,257.44558 c -0.01659,-0.0328 -0.03916,-0.0773 -0.06738,-0.1337 l 0.01516,-0.043 c 0.0042,0.006 0.0088,0.0116 0.01376,0.0183 0.0056,0.008 0.01199,0.0159 0.01871,0.0247 0.0013,0.002 0.0028,0.004 0.0042,0.006 0.0046,0.0349 0.0095,0.0773 0.01553,0.1277",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3089"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.517584,257.308 -0.0028,-0.004 -0.01905,-0.0233 -0.0127,-0.0155 0.01164,-0.0346 c 0.0046,0.002 0.0092,0.004 0.01447,0.006 0.0021,0.0173 0.0049,0.0409 0.0085,0.0706",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.507707,257.22792 -0.01058,-0.004 0.0074,-0.0215 v 0 0 0 0 c 0,0 0.0011,0.008 0.0032,0.0251",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.484776,257.45652 c -0.0071,-0.005 -0.01447,-0.01 -0.02223,-0.0152 -0.0039,-0.0317 -0.0074,-0.0607 -0.01058,-0.0864 l 0.0078,-0.0222 0.02506,0.12383",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.462551,257.44135 c -0.01024,-0.007 -0.02117,-0.0138 -0.03281,-0.0219 l 0.02222,-0.0646 c 0.0032,0.0257 0.0067,0.0547 0.01058,0.0864",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3097"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.539809,257.49285 c -0.01376,-0.009 -0.0321,-0.0212 -0.05503,-0.0363 l -0.02506,-0.12383 0.0032,-0.01 0.07197,0.12947 c 0.0019,0.013 0.0032,0.0261 0.0049,0.0402",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.485834,257.50626 c -7.93e-4,0 -0.0011,0 -0.0019,0 l -0.01799,-0.0325 c 0,-0.002 -2.65e-4,-0.005 -7.94e-4,-0.008 0.0081,0.0162 0.01482,0.0296 0.02045,0.0402",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.495007,257.50696 c -0.0028,-2.6e-4 -0.006,-2.6e-4 -0.0092,-7.9e-4 -0.0056,-0.0106 -0.01236,-0.024 -0.02045,-0.0402 -7.94e-4,-0.004 -0.0011,-0.008 -0.0013,-0.012 l 0.02294,0.0127 0.0081,0.0402",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.48407,257.50626 c -0.0046,-2.7e-4 -0.0092,-2.7e-4 -0.0141,-7.9e-4 -0.0013,-0.0106 -0.0024,-0.0215 -0.0039,-0.0317 l 0.01799,0.0324",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.469959,257.50555 c -0.02011,-0.001 -0.04268,-0.002 -0.06879,-0.004 l 0.024,-0.0688 0.0388,0.0212 c 2.65e-4,0.004 7.94e-4,0.008 0.0013,0.012 2.65e-4,0.003 7.94e-4,0.005 7.94e-4,0.008 0.0013,0.0102 0.0024,0.0212 0.0039,0.0318",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.541574,257.50943 c -0.01164,-7.9e-4 -0.02717,-0.001 -0.04657,-0.002 l -0.0081,-0.0402 0.05327,0.0293 c 2.65e-4,0.004 0.0011,0.009 0.0013,0.0134",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.475251,257.55106 c 0,-2.6e-4 0,-7.9e-4 0,-0.001 0.01728,-0.009 0.02574,-0.013 0.02574,-0.013 l -0.02716,2.6e-4 c -2.65e-4,-7.9e-4 -2.65e-4,-0.001 -2.65e-4,-0.002 0.01834,8e-4 0.02752,10e-4 0.02752,10e-4 v 0 0 l -0.02928,-0.0162 c 0,-0.001 -2.64e-4,-0.002 -2.64e-4,-0.004 0.01976,0.013 0.02963,0.0198 0.02963,0.0198 v 0 0 l -0.01341,-0.0243 h 0.0011 c 0.0085,0.0162 0.01236,0.0243 0.01236,0.0243 v 0 0 l 2.64e-4,-7.9e-4 c -2.64e-4,2.6e-4 -2.64e-4,7.9e-4 -2.64e-4,7.9e-4 v 0 l 2.64e-4,-2.6e-4 c 0,2.6e-4 -2.64e-4,2.6e-4 -2.64e-4,2.6e-4 v 0 0 0 0 0 0 0 0 l 2.64e-4,0.007 c -2.64e-4,0 -2.64e-4,0 -7.93e-4,0 2.64e-4,-0.005 2.64e-4,-0.007 2.64e-4,-0.007 l -0.0056,0.0102 c -2.65e-4,2.6e-4 -0.0011,7.9e-4 -0.0013,7.9e-4 0.0046,-0.007 0.0071,-0.0109 0.0071,-0.0109 l -0.02574,0.0141 m 0.02611,-0.0138 c 0,-2.6e-4 -2.65e-4,-2.6e-4 -2.65e-4,-2.6e-4 v 0 l 2.65e-4,2.6e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 c 0,0 0,-2.6e-4 2.65e-4,-7.9e-4 v 2.6e-4 l -2.65e-4,2.7e-4",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 c 0,0 -0.0039,-0.008 -0.01236,-0.0243 l 0.0078,-2.7e-4 0.0046,0.024 v 8e-4",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 c 0,0 -0.0099,-0.007 -0.02963,-0.0198 -2.65e-4,-0.001 -2.65e-4,-0.003 -7.94e-4,-0.004 l 0.01693,-2.6e-4 0.01341,0.0243",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 c 0,0 -0.0092,-7.9e-4 -0.02752,-10e-4 -7.93e-4,-0.005 -0.0011,-0.01 -0.0019,-0.0148 l 0.02928,0.0162",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.475251,257.55 c -7.94e-4,-0.004 -0.0011,-0.008 -0.0013,-0.0127 l 0.02716,-2.6e-4 c 0,0 -0.0085,0.004 -0.02574,0.013",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.475957,257.55706 c -2.64e-4,-0.002 -2.64e-4,-0.004 -7.93e-4,-0.006 l 0.02574,-0.0141 c 0,0 -0.0024,0.004 -0.0071,0.0109 -0.0056,0.003 -0.01164,0.006 -0.01799,0.009",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.495359,257.54718 0.0056,-0.0102 c 0,0 0,0.002 -2.65e-4,0.007 -0.0019,0.001 -0.0035,0.002 -0.0053,0.003",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501357,257.54436 -2.64e-4,-0.007 c 0,0 2.64e-4,0 2.64e-4,2.7e-4 l 0.0013,0.006 c -7.93e-4,0 -0.0011,2.6e-4 -0.0013,7.9e-4 m -2.64e-4,-0.007 v 0 0 0",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501357,257.53695 h -2.64e-4 v 0 h 2.64e-4 m 0,0 h -2.64e-4 v 0 h 2.64e-4 m -2.64e-4,0 v 0 h 2.64e-4 -2.64e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 v 0 h 2.65e-4 v 2.7e-4 m -2.65e-4,-2.7e-4 v 0 0 0",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 v 0 h 2.65e-4 v 0 m -2.65e-4,0 v 0 0 0",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 v 0 0 0 0 0 0 0 0 m 0,0 v 0 h 2.65e-4 v 0 h -2.65e-4",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.501003,257.53695 v 0 0 0 0 0 0 0 0 c 0,0 2.65e-4,0 2.65e-4,-2.6e-4 v 2.6e-4 h -2.65e-4",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.362361,257.61421 0.03422,-0.0995 0.07408,-0.002 c 2.64e-4,10e-4 2.64e-4,0.003 7.94e-4,0.004 0,0.001 2.64e-4,0.002 2.64e-4,0.004 7.94e-4,0.005 0.0011,0.01 0.0019,0.0148 0,8e-4 0,0.001 2.65e-4,0.002 2.64e-4,0.004 7.94e-4,0.009 0.0013,0.0127 0,2.6e-4 0,7.9e-4 0,0.001 2.64e-4,0.002 2.64e-4,0.004 7.93e-4,0.006 -0.03034,0.0152 -0.06844,0.0346 -0.113596,0.0572",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.502768,257.54365 -0.0013,-0.006 v 0 -10e-4 h -2.65e-4 l -0.0046,-0.024 0.04551,-8e-4 c 2.65e-4,0.004 7.94e-4,0.008 0.0013,0.0116 -0.01024,0.005 -0.024,0.012 -0.04057,0.0205",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.49677,257.61738 c 0.0019,-0.0342 0.0032,-0.0575 0.0039,-0.0699 l 7.94e-4,-2.6e-4 7.93e-4,0.0624 c -0.0019,0.002 -0.0035,0.005 -0.0053,0.008 m -0.01834,-0.0391 c -2.64e-4,-0.002 -2.64e-4,-0.004 -7.94e-4,-0.006 0.0049,-0.007 0.0095,-0.0141 0.0127,-0.0194 l 0.0028,-10e-4 -0.01482,0.0265",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.47772,257.57223 c -2.65e-4,-0.004 -7.94e-4,-0.007 -0.0013,-0.0116 l 0.0141,-0.008 c -0.0032,0.005 -0.0078,0.012 -0.0127,0.0194",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.485128,257.63502 c -0.0024,-0.0194 -0.0046,-0.0384 -0.0067,-0.0568 l 0.01482,-0.0265 0.0074,-0.004 c -7.94e-4,0.0124 -0.0021,0.0356 -0.0039,0.0699 -0.0039,0.006 -0.0078,0.0113 -0.01164,0.0177",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.502061,257.60962 -7.93e-4,-0.0624 0.0019,-10e-4 0.0095,0.0469 c -0.0032,0.005 -0.0071,0.0109 -0.01058,0.0166",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.218076,258.03119 0.140052,-0.40534 0.118181,-0.0653 c 7.94e-4,0.004 0.0011,0.008 0.0013,0.0116 2.65e-4,0.002 2.65e-4,0.004 7.94e-4,0.006 0.0021,0.0183 0.0042,0.0374 0.0067,0.0568 -0.05891,0.0882 -0.14887,0.22225 -0.267052,0.39617",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.512645,257.59304 -0.0095,-0.0469 0.04022,-0.0222 c 7.94e-4,0.006 0.0013,0.0134 0.0021,0.0198 -0.0085,0.0127 -0.01939,0.0293 -0.03281,0.0494",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.504178,257.80153 c -0.0042,-0.0363 -0.0081,-0.0713 -0.01199,-0.10407 0.0011,-0.0205 0.0021,-0.0392 0.0032,-0.0557 l 0.0067,-0.0124 0.0021,0.17216",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.492184,257.69746 c -0.0013,-0.0141 -0.0032,-0.0279 -0.0046,-0.0413 l 0.0078,-0.0145 c -0.0011,0.0166 -0.0021,0.0353 -0.0032,0.0557",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.533811,258.06753 c -0.01058,-0.0963 -0.02045,-0.18486 -0.02963,-0.266 l -0.0021,-0.17215 0.01342,-0.024 0.03598,0.17815 c -0.0046,0.0787 -0.01058,0.17322 -0.01765,0.28399",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.229385,288.63678 c -0.170886,-0.0748 -0.344664,-0.15558 -0.52063,-0.24201 l 10.399961,-30.04819 0.378883,-0.69039 c 0.0013,0.0134 0.0032,0.0272 0.0046,0.0413 0.0039,0.0328 0.0078,0.0677 0.01199,0.10407 0.0092,0.0811 0.01905,0.16969 0.02963,0.266 -0.259995,3.98991 -2.163937,28.12767 -10.304426,30.56925",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.551451,257.78354 -0.03598,-0.17815 0.03069,-0.0564 c 0.0042,0.0342 0.0085,0.0713 0.0127,0.11042 -0.0019,0.0353 -0.0042,0.0766 -0.0074,0.12418",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.231253,271.37995 c 0.04022,-5.52979 -0.413102,-10.61473 -0.653344,-12.90179 l -0.0067,-0.59831 0.02752,0.13441 c 0.221192,2.01753 0.746125,7.51946 0.632529,13.36569",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.789224,277.89434 -0.211315,-19.41618 c 0.240242,2.28706 0.693561,7.372 0.653344,12.90179 -0.04233,2.1777 -0.173567,4.40408 -0.442029,6.51439",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.598724,258.01426 -0.02752,-0.13441 -0.0013,-0.12453 c 0.0092,0.0787 0.01871,0.1651 0.02893,0.25894",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.236588,290.18724 -0.289629,-1.41993 c 5.983459,-6.91797 -6.300258,-31.10018 -6.379281,-31.25576 v 0 l 10.939285,18.02765 c 3.113975,7.3473 3.774725,14.20495 -4.270375,14.64804",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.817799,257.67524 c -0.02222,-0.0145 -0.04304,-0.0282 -0.06244,-0.0413 -0.0046,-0.006 -0.0092,-0.012 -0.01376,-0.018 l 0.05398,0.0321 0.02222,0.0272",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.755357,257.63396 c -0.118533,-0.078 -0.183091,-0.11994 -0.187679,-0.12312 v 0 l 0.173921,0.10513 c 0.0046,0.006 0.0092,0.012 0.01376,0.018",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.897526,257.72851 c -0.02822,-0.019 -0.05503,-0.0367 -0.07973,-0.0533 l -0.02222,-0.0272 0.07726,0.0466 c 0.0081,0.0109 0.01659,0.0226 0.02469,0.0339",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.689386,257.51825 c -0.0074,-2.6e-4 -0.01447,-0.001 -0.02117,-0.001 -0.0028,-0.004 -0.0053,-0.007 -0.0081,-0.0106 l 0.01871,-8e-4 0.01058,0.0127",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.66822,257.51684 c -0.0635,-0.004 -0.09772,-0.006 -0.100894,-0.006 v 0 l 0.09278,-0.005 c 0.0028,0.004 0.0053,0.007 0.0081,0.0106",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.74442,257.52178 c -0.02011,-10e-4 -0.03845,-0.002 -0.05503,-0.004 l -0.01058,-0.0127 0.05151,-0.002 c 0.0046,0.006 0.0092,0.0124 0.0141,0.0187",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.632943,257.46957 c -2.65e-4,-2.6e-4 -0.0011,-7.9e-4 -0.0011,-10e-4 l 0.01093,-0.007 0.0021,0.002 c -0.0042,0.002 -0.0081,0.004 -0.01198,0.006",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.636824,257.47521 c -0.0013,-0.002 -0.0024,-0.004 -0.0039,-0.006 0.0039,-0.002 0.0078,-0.004 0.01198,-0.006 l 0.0042,0.005 c -0.0042,0.002 -0.0085,0.004 -0.01236,0.006",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.567326,257.51084 v 0 l 0.06456,-0.0427 c 0,7.9e-4 7.94e-4,10e-4 0.0011,10e-4 0.0013,0.002 0.0024,0.004 0.0039,0.006 -0.04339,0.0222 -0.06703,0.0342 -0.0695,0.0356",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.64917,257.46886 -0.0042,-0.005 -0.0021,-0.002 0.03775,-0.0251 c 0.0028,0.004 0.006,0.008 0.0088,0.0124 -0.01447,0.007 -0.02822,0.0145 -0.04022,0.0204",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.611776,257.4417 c -0.0011,-0.001 -0.0021,-0.003 -0.0032,-0.004 l 0.006,-0.0106 0.0039,0.005 c -0.0021,0.004 -0.0046,0.007 -0.0067,0.0102",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.567326,257.51049 v 0 l 0.04127,-0.073 c 0.0011,10e-4 0.0021,0.003 0.0032,0.004 -0.02752,0.0427 -0.04268,0.066 -0.04445,0.0688",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.618478,257.43147 -0.0039,-0.005 0.0254,-0.0445 c 0.0019,0.002 0.0039,0.005 0.0056,0.007 -0.0099,0.0152 -0.01905,0.0293 -0.02716,0.0416",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3197"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.574028,257.39125 c -0.0032,-0.004 -0.0067,-0.009 -0.0095,-0.013 l -2.65e-4,-0.0134 0.01058,0.0134 c 0,0.004 -2.65e-4,0.009 -7.94e-4,0.013",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.567326,257.50979 v -2.7e-4 l -0.0028,-0.13123 c 0.0028,0.004 0.0063,0.009 0.0095,0.013 -0.0042,0.072 -0.0064,0.11219 -0.0067,0.11854",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.574734,257.3782 -0.01058,-0.0134 -0.0021,-0.0861 c 0.0056,0.007 0.0113,0.0148 0.01728,0.0229 -0.0013,0.0282 -0.0032,0.0536 -0.0046,0.0766",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.585318,257.40642 c -0.0019,-0.002 -0.0039,-0.005 -0.006,-0.008 l 0.0049,-0.009 0.0067,0.008 c -0.0019,0.003 -0.0035,0.006 -0.0056,0.008",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3205"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.57932,257.39866 c -0.0019,-0.002 -0.0035,-0.005 -0.0053,-0.007 2.65e-4,-0.004 7.94e-4,-0.009 7.94e-4,-0.013 l 0.0095,0.0116 -0.0049,0.009",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3207"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.608601,257.43747 c -0.0078,-0.0106 -0.01553,-0.0212 -0.02328,-0.0311 0.0021,-0.003 0.0039,-0.006 0.0056,-0.008 l 0.02363,0.0289 -0.006,0.0106",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.567326,257.51049 v -7.9e-4 c 2.65e-4,-0.006 0.0024,-0.0466 0.0067,-0.11853 0.0019,0.002 0.0035,0.005 0.0053,0.007 0.0021,0.002 0.0042,0.005 0.006,0.008 0.0078,0.01 0.01553,0.0205 0.02328,0.031 l -0.04127,0.0734",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.614599,257.42688 -0.02363,-0.0289 -0.0067,-0.008 -0.0095,-0.0116 c 0.0013,-0.0229 0.0032,-0.0483 0.0046,-0.0765 0.01765,0.0233 0.0374,0.0497 0.06068,0.0808 l -0.0254,0.0445",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.564503,257.3782 c -0.01199,-0.0155 -0.02294,-0.03 -0.03281,-0.0434 l -0.0028,-0.013 0.03528,0.043 2.65e-4,0.0134",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3215"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.518643,257.24168 c -0.0021,-10e-4 -0.0046,-0.002 -0.0067,-0.003 l -0.0021,-0.0102 0.0095,0.003 c -2.65e-4,0.004 -2.65e-4,0.006 -7.94e-4,0.0102",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.541574,257.2512 c -0.0081,-0.004 -0.01588,-0.007 -0.02294,-0.01 2.64e-4,-0.004 2.64e-4,-0.007 7.94e-4,-0.0102 l 0.0088,0.002 c 0.0042,0.005 0.0085,0.0109 0.01342,0.0173",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.567326,257.50943 -0.03563,-0.17462 c 0.0099,0.0134 0.02082,0.0279 0.03281,0.0434 l 0.0028,0.13123",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.564151,257.36479 -0.03528,-0.043 -0.01693,-0.0832 c 0.0021,0.001 0.0046,0.002 0.0067,0.003 0.0071,0.003 0.01482,0.006 0.02294,0.01 0.006,0.008 0.01304,0.0177 0.02045,0.0275 l 0.0021,0.0861",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.528168,257.23391 -0.0088,-0.002 -0.0095,-0.003 -0.0053,-0.0254 c 0,0 0.0081,0.0106 0.02363,0.031",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 44.946959,288.76731 -6.379281,-31.25576 c 0.07902,0.15558 12.36274,24.33779 6.379281,31.25576",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.942328,257.82799 c -0.02999,-0.0201 -0.05856,-0.0392 -0.08573,-0.0571 -0.0092,-0.0124 -0.01765,-0.024 -0.02681,-0.036 l 0.07161,0.0427 0.04092,0.0504",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 46.087843,268.73659 c -2.992615,-5.12869 -6.118577,-9.4615 -7.23124,-10.96575 0.02717,0.018 0.05574,0.037 0.08573,0.0571 l 0.281871,0.34502 c 1.310921,1.79634 4.199112,5.88645 6.863644,10.56358",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.901407,257.77754 -0.07161,-0.0427 c -0.02574,-0.0349 -0.0508,-0.0691 -0.07444,-0.1009 0.01939,0.013 0.04022,0.0268 0.06244,0.0413 l 0.08361,0.1023",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 49.506963,275.5392 38.567326,257.51084 h 2.65e-4 c 0.0046,0.003 0.06915,0.0452 0.187679,0.12312 0.02363,0.0318 0.04868,0.066 0.07444,0.1009 0.0092,0.012 0.01765,0.0236 0.02681,0.036 1.112662,1.50425 4.238625,5.83706 7.231239,10.96575 1.251654,2.19745 2.453217,4.52296 3.419121,6.80261",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.224199,258.17301 -0.281871,-0.34502 -0.04092,-0.0504 -0.08361,-0.1023 c 0.02469,0.0166 0.0515,0.0342 0.07973,0.0533 0.09419,0.127 0.2032,0.27552 0.326673,0.4445",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.715493,257.55035 c -0.0081,-7.9e-4 -0.01622,-10e-4 -0.02363,-0.002 -0.0053,-0.007 -0.01024,-0.0134 -0.01516,-0.0201 l 0.02011,-0.001 0.01871,0.0229",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.795574,257.64808 -0.05398,-0.0321 c -0.01728,-0.0236 -0.03387,-0.0459 -0.04974,-0.0674 0.0074,8e-4 0.01553,10e-4 0.02363,0.002 l 0.08008,0.0977",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.676686,257.52848 c -0.0032,-0.004 -0.0056,-0.007 -0.0085,-0.0116 0.0067,2.7e-4 0.01376,10e-4 0.02117,10e-4 l 0.0074,0.009 -0.02011,10e-4",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.741599,257.61597 -0.174273,-0.10513 v 0 c 0.0032,0 0.03739,0.002 0.100894,0.006 0.0028,0.004 0.0053,0.007 0.0085,0.0116 0.0049,0.007 0.0099,0.0134 0.01516,0.0201 0.01588,0.0215 0.03245,0.0437 0.04974,0.0674",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.872832,257.69464 -0.07726,-0.0466 -0.08008,-0.0977 -0.01871,-0.0229 -0.0074,-0.009 c 0.01659,10e-4 0.03493,0.002 0.05503,0.004 0.03845,0.0519 0.08114,0.10937 0.128413,0.17287",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.660107,257.50626 c -0.0078,-0.0102 -0.01588,-0.0212 -0.02328,-0.031 0.0039,-0.002 0.0081,-0.004 0.01236,-0.006 l 0.02963,0.0367 -0.01871,8e-4",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.567326,257.51084 v 0 c 0.0024,-10e-4 0.02611,-0.0134 0.0695,-0.0356 0.0074,0.01 0.01553,0.0208 0.02328,0.031 l -0.09278,0.005",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.678803,257.50555 -0.02963,-0.0367 c 0.01199,-0.006 0.02574,-0.013 0.04022,-0.0205 0.01304,0.0173 0.02681,0.0356 0.04092,0.0547 l -0.05151,0.002",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.631884,257.46816 c -0.0032,-0.004 -0.006,-0.007 -0.0088,-0.0116 l 0.01024,-0.007 0.0095,0.0113 -0.01093,0.007",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.623066,257.45652 c -0.0039,-0.005 -0.0074,-0.01 -0.0113,-0.0148 0.0021,-0.003 0.0046,-0.007 0.0067,-0.0102 l 0.01482,0.0183 -0.01024,0.007",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.567326,257.51084 v -2.6e-4 c 0.0019,-0.003 0.01693,-0.0261 0.04445,-0.0688 0.0039,0.005 0.0074,0.01 0.0113,0.0148 0.0028,0.004 0.0056,0.008 0.0088,0.0116 l -0.06456,0.0427",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.64282,257.4611 -0.0095,-0.0113 -0.01482,-0.0183 c 0.0081,-0.0124 0.01728,-0.0265 0.02716,-0.0416 0.01093,0.0145 0.02257,0.0303 0.03493,0.0462 l -0.03775,0.0251",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 60.379578,279.6794 c -1.52506,-8.34672 -18.533535,-19.98698 -21.402677,-21.89833 l -0.0381,-0.0466 19.047177,11.46317 c 3.43006,3.40889 5.13786,7.11094 2.3936,10.48173",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3263"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.324386,257.5627 c -0.03069,-0.002 -0.06103,-0.005 -0.08996,-0.007 -0.03775,-0.0169 -0.07479,-0.0332 -0.110067,-0.049 l 0.06809,-0.003 c 0.04233,0.0187 0.08608,0.0384 0.131937,0.0589",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3265"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.124361,257.50696 c -0.01588,-0.007 -0.03104,-0.0138 -0.04657,-0.0205 l 0.06809,-0.004 c 0.01553,0.007 0.03069,0.0138 0.04657,0.0208 l -0.06809,0.003",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.234428,257.556 c -0.198967,-0.0148 -0.356304,-0.0254 -0.468135,-0.0328 l -0.01728,-0.0212 0.328788,-0.0155 c 0.01553,0.007 0.03069,0.0134 0.04657,0.0205 0.03528,0.0159 0.07232,0.0321 0.110067,0.049",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.822736,257.37361 c -0.0099,-0.004 -0.01905,-0.008 -0.02857,-0.0123 l 0.03034,-0.0201 c 0.01093,0.005 0.02223,0.01 0.03387,0.0148 -0.01199,0.006 -0.02434,0.012 -0.03563,0.0176",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3271"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.830499,257.37714 c -0.0024,-10e-4 -0.0053,-0.002 -0.0078,-0.004 0.0113,-0.006 0.02363,-0.0116 0.03563,-0.0176 0.0024,10e-4 0.0049,0.002 0.0074,0.004 -0.01199,0.006 -0.02363,0.012 -0.03528,0.0176",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.700676,257.44276 -0.01058,-0.013 0.104068,-0.0684 c 0.0095,0.004 0.01871,0.008 0.02857,0.0124 0.0024,10e-4 0.0053,0.002 0.0078,0.004 -0.05045,0.0254 -0.09349,0.0473 -0.129824,0.0656",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.692916,257.31682 c -0.0042,-0.002 -0.0085,-0.004 -0.0127,-0.005 l 0.01482,-0.0265 0.0011,2.6e-4 c 0.0046,0.002 0.0092,0.004 0.01376,0.006 -0.006,0.009 -0.0113,0.0177 -0.01693,0.0257",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3277"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.650934,257.38173 -0.0063,-0.007 0.03563,-0.0628 c 0.0042,0.002 0.0085,0.004 0.0127,0.005 -0.01553,0.024 -0.02963,0.0455 -0.04198,0.0649",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.696091,257.28542 -0.0011,-2.6e-4 v -2.7e-4 c 2.65e-4,2.7e-4 7.94e-4,2.7e-4 0.0011,7.9e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.581436,257.26849 c -0.0067,-0.003 -0.01341,-0.006 -0.01976,-0.008 l -2.65e-4,-0.0159 0.02117,0.006 c -2.65e-4,0.006 -7.94e-4,0.0124 -0.0011,0.018",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.580026,257.29494 -0.01799,-0.0219 -2.64e-4,-0.013 c 0.0063,0.003 0.01304,0.006 0.01976,0.008 -2.64e-4,0.009 -0.0011,0.018 -0.0013,0.0264",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.582495,257.25049 -0.02117,-0.006 -2.65e-4,-0.0173 c 0.0071,0.003 0.01447,0.006 0.02257,0.01 -2.64e-4,0.005 -7.93e-4,0.009 -0.0011,0.0138",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.654816,257.30024 c -0.0056,-0.002 -0.01058,-0.005 -0.01588,-0.007 l 0.01236,-0.0219 0.01834,0.006 c -0.0053,0.008 -0.0099,0.0152 -0.01482,0.0229",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.638941,257.29353 c -0.02082,-0.009 -0.03986,-0.0173 -0.0575,-0.025 2.65e-4,-0.006 7.94e-4,-0.012 0.0011,-0.018 l 0.06879,0.0212 -0.01236,0.0219",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.680216,257.31153 c -0.0088,-0.004 -0.01728,-0.008 -0.0254,-0.0113 0.0049,-0.008 0.0095,-0.0148 0.01482,-0.0229 l 0.0254,0.008 -0.01482,0.0265",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3293"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.644584,257.37432 -0.06456,-0.0794 c 2.65e-4,-0.008 0.0011,-0.0173 0.0013,-0.0264 0.01765,0.008 0.03669,0.0159 0.0575,0.025 0.0053,0.002 0.01024,0.005 0.01587,0.007 0.0081,0.004 0.01659,0.007 0.0254,0.0113 l -0.03563,0.0628",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.695032,257.28507 -0.0254,-0.008 -0.01834,-0.006 -0.06879,-0.0212 c 2.65e-4,-0.005 7.94e-4,-0.009 0.0011,-0.0138 0.02928,0.0124 0.06667,0.0286 0.111479,0.048 v 2.7e-4",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.561682,257.26002 c -0.0053,-0.002 -0.01093,-0.005 -0.01588,-0.007 l -0.01516,-0.0187 0.03069,0.01 2.64e-4,0.0159",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.562034,257.27307 -0.01622,-0.0198 c 0.0049,0.002 0.01058,0.004 0.01587,0.007 l 2.65e-4,0.013",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.561328,257.24414 -0.03069,-0.01 -0.02611,-0.0317 c 0,0 0.01939,0.008 0.05644,0.024 l 2.65e-4,0.0173",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 58.369798,281.5209 38.976901,257.78107 c 2.869142,1.91135 19.877617,13.55161 21.402677,21.89833 -0.51012,0.62689 -1.17405,1.24178 -2.00978,1.8415",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.406584,257.59939 c -0.03104,-0.002 -0.06068,-0.005 -0.08996,-0.007 -0.02822,-0.0127 -0.05539,-0.0247 -0.0822,-0.0367 0.02893,0.002 0.05927,0.004 0.08996,0.007 0.02681,0.012 0.05433,0.0243 0.0822,0.0367",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 47.408643,261.64893 c -3.519313,-1.95545 -6.630811,-3.40184 -8.092017,-4.05624 0.02928,0.002 0.05891,0.005 0.08996,0.007 1.471084,0.66111 4.568825,2.10891 8.002059,4.04954",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 57.985978,269.19767 38.938801,257.7345 38.766293,257.52319 c 0.111831,0.007 0.269168,0.018 0.468135,0.0328 0.02681,0.012 0.05398,0.024 0.0822,0.0367 1.461206,0.6544 4.572704,2.10079 8.092017,4.05624 3.668883,2.07398 7.720543,4.70993 10.577333,7.54874",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.077795,257.4865 c -0.09137,-0.0409 -0.174271,-0.0773 -0.247296,-0.10936 0.01164,-0.006 0.02328,-0.0116 0.03528,-0.0176 0.08078,0.0353 0.174625,0.0765 0.280106,0.12347 l -0.06809,0.004",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.749007,257.50203 -0.04833,-0.0593 c 0.03634,-0.0183 0.07937,-0.0402 0.129823,-0.0656 0.07303,0.0321 0.155927,0.0684 0.247296,0.10936 l -0.328788,0.0155",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3315"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.794161,257.36127 c -0.0053,-0.002 -0.01058,-0.005 -0.01588,-0.007 l 0.03034,-0.0201 c 0.0053,0.002 0.01058,0.005 0.01587,0.007 l -0.03034,0.0201",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.778286,257.35421 c -0.03034,-0.013 -0.05891,-0.0257 -0.08537,-0.0374 0.0056,-0.008 0.01093,-0.0166 0.01693,-0.0257 0.02963,0.013 0.06279,0.0275 0.09878,0.043 l -0.03034,0.0201",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.690093,257.4297 -0.03916,-0.048 c 0.01236,-0.0194 0.02646,-0.0409 0.04198,-0.0649 0.02646,0.0116 0.05503,0.0243 0.08537,0.0374 0.0053,0.002 0.01058,0.005 0.01588,0.007 l -0.104068,0.0684",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 72.321808,267.52197 -6.69819,-2.04399 c -5.02073,-5.78626 -21.196655,-7.50006 -25.814867,-7.87718 l -0.423333,-0.12911 20.62798,-0.98884 c 8.96866,0.74613 16.44826,3.44629 12.30841,11.03912 m -33.39853,-10.19139 -0.05644,-0.0173 0.289277,-0.19085 c 0.07479,-0.009 0.155223,-0.018 0.241655,-0.0282 -0.188738,0.0935 -0.34784,0.17287 -0.474488,0.23637 m -0.199319,-0.061 -0.01728,-0.005 0.05327,-0.0942 c 0.01024,-10e-4 0.02045,-0.002 0.0314,-0.004 -0.02434,0.0374 -0.04692,0.0716 -0.06738,0.10301 m -0.1397,-0.0423 -0.02328,-0.007 -7.94e-4,-0.0247 c 0.0081,-10e-4 0.01659,-0.002 0.02612,-0.003 -7.94e-4,0.012 -0.0013,0.0236 -0.0021,0.0349",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.706674,257.2646 -0.122415,-0.0374 c 7.94e-4,-0.0113 0.0013,-0.0229 0.0021,-0.0349 0.04198,-0.005 0.100542,-0.0127 0.173567,-0.0219 l -0.05327,0.0942",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.560976,257.22015 -0.05644,-0.0173 c 0,0 0.01905,-0.002 0.05574,-0.007 l 7.93e-4,0.0247",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.623618,265.47798 39.808751,257.6008 c 4.618212,0.37712 20.794137,2.09092 25.814867,7.87718",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.385418,257.47169 -0.46214,-0.14111 c 0.126648,-0.0635 0.28575,-0.14288 0.474488,-0.23637 2.174875,-0.25117 8.029572,-0.85196 14.285032,-0.85196 2.10643,0 4.25802,0.0681 6.3306,0.2406 l -20.62798,0.98884",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.866834,257.31329 -0.142875,-0.0437 c 0.02045,-0.0314 0.04304,-0.0656 0.06738,-0.10301 0.09807,-0.012 0.220133,-0.0268 0.36477,-0.0441 l -0.289277,0.19085",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.56027,257.18876 -2.65e-4,-0.0145 0.02787,-0.007 c -2.65e-4,0.005 -7.94e-4,0.0102 -7.94e-4,0.0152 l -0.02294,0.006 c -0.0013,0 -0.0024,2.6e-4 -0.0039,2.6e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.56027,257.18946 v -7.9e-4 c 0.0013,0 0.0024,-2.7e-4 0.0039,-2.7e-4 l -0.0039,10e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.559918,257.17429 -2.65e-4,-0.0138 c 0.0092,-0.007 0.01905,-0.0145 0.03034,-0.0229 -7.94e-4,0.01 -0.0013,0.0204 -0.0021,0.03 l -0.02787,0.007",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.779345,257.13584 0.0099,-0.0173 0.03986,-0.01 c -0.0039,0.006 -0.0078,0.0123 -0.01164,0.018 l -0.0381,0.009",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3341"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.789224,257.11855 0.130527,-0.23071 c 0.03457,-0.0258 0.07126,-0.0533 0.109715,-0.0822 -0.07585,0.11395 -0.142523,0.21555 -0.20038,0.30304 l -0.03986,0.01",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.344495,256.99826 0.03598,-0.0236 0.489304,-0.11888 c -0.02045,0.01 -0.04127,0.0201 -0.06138,0.0296 l -0.463904,0.11289",
    style: {
      fill: "#002002",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.808399,256.88537 c 0.02011,-0.01 0.04092,-0.0198 0.06138,-0.0296 l 0.02928,-0.007 c -0.02082,0.0102 -0.04092,0.0201 -0.06138,0.03 l -0.02928,0.007 m 31.633229,-7.69761 c -0.007,-0.004 -0.013,-0.007 -0.0198,-0.0109 l 2.20945,-0.53763 c 0,0.006 0,0.01 0,0.0155 l -2.18969,0.53305",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.380478,256.97462 16.46802,-10.85532 c 4.35046,-2.21439 8.71785,-3.87385 12.03678,-3.87385 3.39478,0 5.6903,1.73707 5.74604,6.39374 l -2.20945,0.53763 c -1.20156,-0.64029 -2.75695,-0.91334 -4.53707,-0.91334 -8.66246,0 -22.640927,6.46747 -26.985737,8.58485 l -0.02928,0.007 -0.489304,0.11888",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.719726,257.1503 0.0099,-0.0173 0.04127,-0.01 c -0.0042,0.006 -0.0081,0.012 -0.01199,0.0177 l -0.03916,0.01",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.587082,257.18276 c 0,-0.005 2.65e-4,-0.01 7.94e-4,-0.0152 l 0.141817,-0.0346 -0.0099,0.0173 -0.132644,0.0325",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.758884,257.14078 c 0.0039,-0.006 0.0078,-0.0116 0.01199,-0.0177 l 0.01834,-0.005 -0.0099,0.0173 -0.02045,0.005",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.587786,257.16759 c 7.94e-4,-0.01 0.0013,-0.0201 0.0021,-0.03 0.0695,-0.0529 0.180623,-0.13722 0.329848,-0.24976 l -0.130527,0.23071 -0.01834,0.005 -0.04128,0.01 -0.141817,0.0346",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.515468,257.1944 c 0.0019,-10e-4 0.0039,-0.003 0.0064,-0.005 0,0.001 0,0.003 0,0.004 -0.0024,2.6e-4 -0.0042,7.9e-4 -0.0064,7.9e-4",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.521818,257.1937 c 0,-10e-4 0,-0.003 0,-0.004 0.0035,-0.002 0.0071,-0.005 0.0113,-0.008 l 0.02681,-0.007 2.64e-4,0.0145 c -0.0141,0.002 -0.02681,0.004 -0.03845,0.005",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.504532,257.20287 c 0,0 0.0035,-0.003 0.01093,-0.008 0.0021,0 0.0039,-2.6e-4 0.0063,-7.9e-4 0.01164,-10e-4 0.02434,-0.003 0.03845,-0.005 v 8e-4 l -0.05574,0.0134 v 0",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.533107,257.181 c 0.0074,-0.006 0.01622,-0.0124 0.02646,-0.0205 l 2.64e-4,0.0138 -0.02681,0.007",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.837678,256.87831 c 0.02045,-0.01 0.04057,-0.0198 0.06138,-0.03 l 31.52281,-7.67151 c 0.007,0.004 0.013,0.007 0.0198,0.0109 l -31.60395,7.69056",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.899061,256.84833 c 4.34481,-2.11738 18.323277,-8.58485 26.985737,-8.58485 1.78012,0 3.33551,0.27305 4.53707,0.91334 l -31.522807,7.67151",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.302516,257.00884 0.03598,-0.024 0.04198,-0.0102 -0.03598,0.0236 -0.04198,0.0106",
    style: {
      fill: "#398d5b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.817445,257.12667 c 0.0039,-0.006 0.0078,-0.012 0.01164,-0.018 l 0.509413,-0.12383 -0.03598,0.024 -0.485071,0.11783",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.829086,257.10868 c 0.05786,-0.0875 0.124532,-0.18909 0.20038,-0.30304 1.99531,-1.49578 9.38177,-6.90068 16.819032,-10.68634 l -16.46802,10.85532 -0.04198,0.0102 -0.509413,0.12383",
    style: {
      fill: "#59001a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 44.56102,257.07234 c 0,3.34645 -2.712509,6.06002 -6.059663,6.06002 -3.346804,0 -6.059664,-2.71357 -6.059664,-6.06002 0,-3.3468 2.71286,-6.06001 6.059664,-6.06001 3.347154,0 6.059663,2.71321 6.059663,6.06001",
    style: {
      fill: "#049b00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778,
      opacity: 1
    },
    id: "path3377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower20);
export default __webpack_public_path__ + "static/media/flower-20.760825234f563e490aac333d18d3dbe8.svg";
export { ForwardRef as ReactComponent };